import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SecurityContext,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentType } from 'src/app/modules/bookkeeping/enums/document-type';
import { fromCamelCase } from 'src/app/core/util/camel-case-converter';
import { EnumItem } from '../../models/enum-item';
import { RecognizedInvoiceService } from '../../services/recognized-invoice.service';
import { finalize, map, take, takeUntil } from 'rxjs/operators';
import { Invoice } from '../../models/invoice/invoice';
import { OrganizationService } from 'src/app/data/service/organization.service';
import { ToasterMessageService } from 'src/app/shared/toaster-message/toaster-message.service';
import { ToasterTypes } from 'src/app/core/enum/toaster-type.enum';
import { NewSupplier } from '../../models/supplier/new-supplier';
import { SuppliersService } from 'src/app/data/service/suppliers.service';
import { InvoiceService } from 'src/app/data/service/invoice.service';
import { Router } from '@angular/router';
import { dateToString, stringToDate } from 'src/app/core/util/date-converter';
import { enumSelector } from 'src/app/core/util/enum-selector';
import { SupplierShort } from '../../models/supplier/supplier-short';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { BankAccountService } from 'src/app/data/service/bank-account.service';
import { PaymentAccount } from '../../models/account/payment-account';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { InvoiceLine } from '../../models/invoice/invoice-line';
import { AccountCodingCopyPayload } from '../../models/invoice/account-coding-suggestion';
import { Guid } from 'guid-typescript';
import { InvoiceTotals } from '../../models/invoice/invoice-totals';
import { CreatedInvoiceWithLines } from '../../models/invoice/created-invoice-with-lines';
import { tryGetObjectByProperty } from 'src/app/core/util/get-object-by-property';
import { TaxRate } from '../../models/taxRate';
import { round } from 'src/app/core/util/round';
import { CurrencyCode } from '../../enums/currency-code';
import { TrackingCategory } from '../../models/tracking-categories.ts/trackingCategory';
import { TrackingCategoryOption } from '../../models/tracking-categories.ts/tracking-category-option';
import { QBOClass } from '../../models/qbo-class';
import { QBOCustomer } from '../../models/qbo-customer';
import { SupplierWithAlias } from '../../models/supplier/supplier-with-alias';
import { BankAccount } from '../../models/account/bank-account';
import { ConfirmationDialogService } from 'src/app/shared/confirmation-dialog/confirmation-dialog.service';
import { SupplierAccountCreated } from '../../models/supplier/supplier-account-created';
import { Converter } from 'src/app/core/util/number-converter';
import { CreditNoteDTO } from '../../models/credit-note/credit-note';
import { SharedService } from '../../services/shared-service';
import { forkJoin, of, Subscription } from 'rxjs';
import { AccountingIntegration } from 'src/app/data/enums/accounting-integration';
import { InboxInvoicesStorageService } from '../../services/inbox-invoices-storage.service';
import { ActivatedRoute } from '@angular/router';
import { InvoicePaymentStatus } from '../../enums/payment-status';
import { UserService } from 'src/app/data/service/user.service';
import { User } from '../../models/user/user';
import { UpdatedLines } from '../../models/invoice/updated-lines';
import { BillsToPayInvoiceDetailsRequest } from '../../models/invoice/bills-to-pay-invoice-details-request';
import { ArchiveInvoice } from '../../models/invoice/archive-request';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { SyncedExpClaims } from '../../models/invoice/invoice-exp-claims';
import * as $ from 'jquery';

import { Pannels } from 'src/app/modules/bookkeeping/enums/sidebar-pannels';
import { sumOfArrayByProperty } from '../../../../core/util/sum-of-array-by-property';
import { TaxBasis } from '../../enums/taxBasis';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { BankTransactionDTO } from '../../models/expense/bank-transactions';
import { DomSanitizer } from '@angular/platform-browser';
import { UnreconciledReport } from '../../models/invoice/unreconciled-report';
import {
  customFields,
  customFields_Values,
} from '../../models/custom-fields/custom-fields';
import { MatDatepicker } from '@angular/material/datepicker';
import { EntertainmentDetailsComponent } from '../../entertainment-details/entertainment-details.component';
import { MatDialog } from '@angular/material/dialog';
import {
  FormType,
  FormAssignment,
  AssignmentStatus,
} from '../../models/form-assignment';
import { FormAssignmentDialogComponent } from '../../components/form-assignment-dialog/form-assignment-dialog.component';
import { TaskDetailsDialogComponent } from '../../components/task-details-dialog/task-details-dialog.component';
import { CustomFieldService } from 'src/app/data/service/customFields.service';
import { ReportService } from 'src/app/data/service/report.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UpdatedSettings } from '../../models/settings/updated-settings';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import {
  InvoiceDisplaySettings,
  DEFAULT_INVOICE_DISPLAY_SETTINGS,
} from '../../models/invoice-display-settings';
import { InvoiceDisplaySettingsDialogComponent } from '../../components/invoice-display-settings-dialog/invoice-display-settings-dialog.component';
import { RecordReviewContext } from 'src/app/modules/tasks/record-review';

/**
 * Utility function to parse date string according to organization's format
 * @param dateStr Input date string to parse
 * @param format Format string ('en-GB' or 'en-US', etc.)
 * @returns Date object if successfully parsed, null otherwise
 */
function parseDateByFormat(dateStr: string, format: string): Date | null {
  // Safety check
  if (!dateStr || typeof dateStr !== 'string') {
    return null;
  }
  // Determine if GB format (dd/MM/yyyy)
  const isGBFormat = format === 'en-GB' || format.toLowerCase().includes('gb');
  // Clean up input - remove any non-digit or separator characters
  const cleanDate = dateStr.trim().replace(/[^\d\/\-\.]/g, '');

  // Split by any common date separator (/, -, .)
  const parts = cleanDate.split(/[\/\-\.]/);

  if (parts.length !== 3) {
    console.log('Invalid date format: does not have 3 parts');
    return null;
  }

  let day: number, month: number, year: number;

  // Parse based on format
  if (isGBFormat) {
    // GB: day/month/year
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10); // JS months are 0-indexed
    year = parseInt(parts[2], 10);
  } else {
    // US: month/day/year
    month = parseInt(parts[0], 10);
    day = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  }

  // Handle 2-digit years by converting to 21st century
  if (year < 100) {
    year = 2000 + year;
  }

  // Create and validate the date
  const result = new Date(year, month, day);

  // Check if date is valid (e.g., not Feb 31st)
  if (isNaN(result.getTime())) {
    return null;
  }

  // Validate that the parsed date components match what we expect
  // This catches edge cases like JS auto-correcting Feb 31 to Mar 3
  if (result.getDate() !== day || result.getMonth() !== month || result.getFullYear() !== year) {
    return null;
  }

  return result;
}

enum PaymentViewState {
  JustShowValues,
  AddPaymentAccount,
  SameValues,
  DifferentValues,
  SaveNewValues,
  HideWarning,
}

@Component({
  selector: 'app-upload-invoice-form',
  templateUrl: './upload-invoice-form.component.html',
  styleUrls: ['./upload-invoice-form.component.scss'],
  // The approval open on this bill, shared by the footer's approval block and every
  // [recordField] in the form, lines included.
  providers: [RecordReviewContext],
})
export class UploadInvoiceFormComponent
  extends BaseComponent
  implements OnInit, AfterViewInit {
  @Input() currentPannel: Pannels;
  @Input() isEditable: boolean = false;
  @Input() billsToPayMode: boolean = false;
  /** Opened from a note on the list, so the Activity tab starts on Notes. */
  @Input() openNotesFirst: boolean = false;
  @Input() isInboxMode: boolean = false;
  @Input() isInboxMobileMode: boolean = false;
  @Input() approvalMode: boolean = false;
  @Input() hexColorClass: string = '';
  @Input() heightDeduct: number = 192;
  @Input() invoiceTaskMode: boolean = false;
  @Input() currentSelectedMatch: string = "";
  // Inbox overlay mode: rendered inside the inbox table via a query-param `id`
  // instead of the editInvoice/viewInvoice route, so prev/next swaps in place
  // and the active id comes from the host rather than the route param.
  @Input() overlayMode: boolean = false;
  @Input() currentInvoiceId: string;
  @Output() updateDirection = new EventEmitter<void>();
  @Output() updateActionBar = new EventEmitter<void>();
  @Output() closeFormOnBillsToPayEvent = new EventEmitter<void>();
  @Output() closeFormOnDeletePublish = new EventEmitter<string>();
  @Output() invoiceApprovedEvent = new EventEmitter<string>();
  @Output() closeFormOnMatch = new EventEmitter<void>();
  @Output() loadingChanged = new EventEmitter<boolean>();
  /** Carries the id of the invoice that was deleted. Must be explicit — the overlay has already
   *  moved to the next bill by the time this fires. */
  @Output() onDeleteDocument = new EventEmitter<string>();
  @Output() navigateInvoice = new EventEmitter<{ id: string; editMode: boolean }>();
  // Fires with the id of a bill that was just published so the host can drop it
  // from the inbox table in the background (it has left "For Review").
  @Output() invoicePublished = new EventEmitter<string>();
  /**
   * A field change was saved. Carries the invoice as it now stands, so a list behind the form
   * (the Inbox) can show the change without a reload.
   */
  @Output() invoiceSaved = new EventEmitter<Invoice>();
  // Id of the bill being published — captured before the optimistic advance so
  // the published id (not the next bill's) is emitted once the publish succeeds.
  private _publishedInvoiceId: string | null = null;

  isActionBarShown: boolean = true;
  form!: FormGroup;
  // Expense Claim is hidden from the Type picker for now (still handled on load
  // so existing expense-claim records resolve correctly). Remove the filter to
  // re-enable it.
  types: EnumItem[] = enumSelector(DocumentType, fromCamelCase)
    .filter((t) => t.key !== DocumentType['Expense Claim']);
  suppliers: SupplierShort[] = [];
  supplierSearchList: SupplierShort[] = [];
  accounts: PaymentAccount[] = [];
  bankAccountList: PaymentAccount[] = [];
  reportName: string = '';
  selectedBankAccount: string;
  MyBankAccount: any;
  userDetails: any;
  userRole: number;
  listOfSelectedRecords: any = [];
  isLoaded: boolean = false;
  isNewSupplierLoaded: boolean = false;
  isSaveLoader: boolean = false;
  isNewSupplier: boolean = false;
  isAddLinesFormShown: boolean = false;
  isTotalsShown: boolean = false;
  isAliasWarningShown: boolean = false;
  isReportWarningShown: boolean = false;
  isDuplicateWarningShown: boolean = false;
  currentSupplier: SupplierWithAlias = new SupplierWithAlias();
  currentTotalTax: number;
  newSupplier: NewSupplier = new NewSupplier(
    this._organizationService.selectedOrganization
  );
  invoice: Invoice = new Invoice(
    this._organizationService.selectedOrganization
  );

  creditNote: CreditNoteDTO = new CreditNoteDTO(
    this._organizationService.selectedOrganization
  );
  bankTransation: BankTransactionDTO = new BankTransactionDTO(
    this._organizationService.selectedOrganization
  );
  account: PaymentAccount = new PaymentAccount();
  taxRates: TaxRate[] = [];
  taxRate: TaxRate;
  selectedTaxRateId: string;
  selectedExclusivTaxRateId: string;
  organizationTaxRateId: string;
  isDifferentTaxAmount: boolean = false;
  isAccountWarningShown: boolean = false;
  currencies: string[] = []; // = Object.keys(CurrencyCode);
  trackingCategories: TrackingCategory[] = [];
  selectedOptions: TrackingCategoryOption[] = [];
  selectedTrackingCategories = [null, null];
  qboClasses: QBOClass[] = [];
  selectedQBOClassId: string = null;

  get invoiceClassName(): string {
    const line = this.invoice?.invoiceLines?.find((l) => !!l.className || !!l.classId);
    return line?.className || '';
  }

  get selectedClassName(): string {
    if (!this.selectedQBOClassId) { return ''; }
    const match = this.qboClasses?.find((c) => c.id === this.selectedQBOClassId);
    return match?.name || '';
  }
  bankAccount: BankAccount = new BankAccount(
    this._organizationService.selectedOrganization
  );
  bankName: string = '';
  defaultCurrency: CurrencyCode;
  converter = new Converter();
  type = '';
  invoiceSelectedType = '';
  lineItemList = [];
  loading: boolean = false;
  qboTaxDefault = { id: '0', name: 'Ignore Tax', rate: 0, taxType: '' };
  integrationType: 'Xero' | 'QBO' | 'None' = 'None';
  IsQuickBook: boolean = false;
  IsNoAccounting: boolean = false;
  IsXero: boolean = false;
  // Org-level invoice panel display preferences (SD-1177). Starts with the
  // defaults so the panel renders correctly before settings load / if none exist.
  displaySettings: InvoiceDisplaySettings = DEFAULT_INVOICE_DISPLAY_SETTINGS;
  // Tracks when the user edits Planned Date so it autosaves like Due Date (SD-1177).
  plannedDateChanged: boolean = false;
  // QBO Customers (SD-1177) — mirrors qboClasses.
  customers: QBOCustomer[] = [];
  selectedCustomerId: string = null;

  get invoiceCustomerName(): string {
    const line = this.invoice?.invoiceLines?.find((l) => !!l.customerName || !!l.customerId);
    return line?.customerName || '';
  }

  get selectedCustomerName(): string {
    if (!this.selectedCustomerId) { return ''; }
    const match = this.customers?.find((c) => c.id === this.selectedCustomerId);
    return match?.name || '';
  }
  // Soft reminder when the invoice date is more than 12 months old (dismissable).
  oldDateNoticeDismissed: boolean = false;
  DefaultTaxSelect: boolean = false;
  subscriptions: Subscription[] = [];
  taxRatesLoading: boolean = false;

  showToolTipDelay: number = 400;
  isNextDisabled: boolean = true;
  isPrevioustDisabled: boolean = false;
  paymentStatusValues = [
    InvoicePaymentStatus.AwaitingProcessing,
    InvoicePaymentStatus.AwaitingPayment,
    InvoicePaymentStatus.Paid,
    InvoicePaymentStatus.Archived,
    InvoicePaymentStatus.Void,
  ];
  showPublishValidation: boolean = false;
  isSpinnerShown: boolean = true;
  pairs: string = '';
  isJsonKeyValueShown: boolean = false;
  user = {} as User;
  isKVPMenuItemShown: boolean = false;
  fieldWasChanged: boolean = false;
  localCurrencyWasChanged: boolean = false;
  dateLoading: boolean = false;
  dueDateLoading: boolean = false;
  paymentDateLoading: boolean = false;
  invoiceColorNumber: number = 1;
  fieldName: string = '';

  paymentViewStateValues = PaymentViewState;
  paymentViewStateValue = {} as PaymentViewState;
  showPaymentAccountFields: boolean = false;
  showUSPaymentAccountFields: boolean = false;
  warningIsReadyToBeShown: boolean = false;
  showRecalculate: boolean = false;

  panels = Pannels;
  dateFormat: string = null;
  returnBackToText: string = null;
  addDefaultAccountLoading: boolean = false;
  supplierSearchTerm: string = null;
  creatingNewSupplier: boolean = false;
  readonlySupplierField: boolean = true;
  isCreateSupplierItemShown: boolean = false;
  isApproving: boolean = false;
  isApproveButtonShown: boolean = false;
  /** An approval block is showing in the footer, in place of Publish. */
  approvalActive = false;
  private _reviewKey: string = null;
  private _reviewIds: string[] = [];
  isExpClaim: boolean = false;
  isReceipt: boolean = false;
  users: User[] = [];
  expClaims: SyncedExpClaims[] = [];

  isNewExpReportLoaded: boolean = false;
  isNewExpReport: boolean = false;
  currentExpReport: SyncedExpClaims = new SyncedExpClaims();
  newExpReport: SyncedExpClaims = new SyncedExpClaims();
  isCreateExpReportItemShown: boolean = false;
  creatingNewExpReport: boolean = false;
  expenseReportIdInvalid: boolean = false;
  paidByInvalid: boolean = false;
  referencePlaceholder: string =
    'SYNC-' + Math.floor(100000 + Math.random() * 900000).toString();
  supplierName: string = '';
  countryCode: string = '';
  paymentStatusItem: any = [];
  selectedUnreconciledReportId: string = '';
  showMatchDialog: boolean = true;
  // Whether the Possible Match list is expanded. Header is always visible (with
  // the count and the selected match's summary); collapsing hides the cards so
  // the user can see the invoice form behind without dismissing the panel.
  isMatchPanelExpanded: boolean = true;
  // When false, only the top match is shown; the rest are revealed via the
  // "Show N more" button below the list. The chevron in the header still
  // collapses/expands the entire panel independently.
  showAllMatches: boolean = false;
  unreconciledReportIds: string = '';
  maindivHeight: boolean;
  showSupplierTooltip: boolean = false;
  showRefTooltip: boolean = false;
  showAccountTooltip: boolean = false;
  isPageLoaded: boolean = false;
  isMatchPublish: boolean = false;
  isHorizontalDirection: boolean = false;
  isMobileDevice: boolean = false;
  isPreviewVisible: boolean = false;
  isPreviewVisibleWeb: boolean = false;
  orgTaxBasis: TaxBasis = TaxBasis.DefaultRate;

  expanded: boolean = false;
  customFields: customFields[] = [];
  customFormFields: customFields[] = [];
  formTypes: any = [];

  private readonly bsbPattern = /\d{3}-\d{3}/gi;
  private readonly accountNumberPattern = /^[0-9]*$/gi;
  private readonly routingPattern = /^[0-9]*$/gi;

  showEntertainmentForm = false;

  // Add new class properties
  isApproved: boolean = false;
  showApprovalAnimation: boolean = false;
  tasks: any[] = [];
  completedTasks: any[] = [];

  pendingTaskCount: number = 0;
  showApprovedTag: boolean = false;
  formId: number = 0;
  taskId: string = '';
  formName: string = '';
  assignToUserName: string = '';
  isFormEditable: boolean = true;
  currentTaskCompleted: boolean = false;

  // Add new properties
  exchangeRate: number = null;
  showLocalCurrency: boolean = false;
  dateChanged: boolean = false;
  dueDateChanged: boolean = false;
  currencyChanged: boolean = false;
  canPublish: boolean = false;
  isoutlookEnv: boolean = environment.isOutlookEnv;
  isChromeEnv: boolean = environment.isChromeEnv;
  currentUser: any;

  @ViewChild('DefaultTaxModel') DefaultTaxModel: ModalDirective;
  @ViewChild('autosize') autosize!: CdkTextareaAutosize;

  constructor(
    private _recognizedInvoiceService: RecognizedInvoiceService,
    private _organizationService: OrganizationService,
    private _suppliersService: SuppliersService,
    private _invoiceService: InvoiceService,
    private _toasterMessageService: ToasterMessageService,
    private _bankAccountService: BankAccountService,
    private _confirmationDialogService: ConfirmationDialogService,
    private _router: Router,
    private _sharedService: SharedService,
    private _inboxInvoicesStorage: InboxInvoicesStorageService,
    private _activatedRoute: ActivatedRoute,
    private _userService: UserService,
    private readonly _renderer: Renderer2,
    private _adapter: DateAdapter<any>,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private customFieldService: CustomFieldService,
    private reportService: ReportService,
    private ngZone: NgZone
  ) {
    super();
    this.dateFormat = this._organizationService.selectedOrganizationDateFormat;
    if (this.dateFormat != null) {
      this._adapter.setLocale(this.dateFormat);
    }
    this.getSuppliers();
    this.getFormTypes();
  }

  getFormTypes() {
    this.customFieldService
      .GetAllForms(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe((formTypes: any) => {
        this.formTypes = formTypes?.data || [];
      });
  }

  loadPaymentStatus(value = null) {
    let paymentStatusItem: any = [];
    if (value != 'EXP' && value != 'Receipt') {
      paymentStatusItem.push({
        name: 'Awaiting Payment',
        value: InvoicePaymentStatus.AwaitingProcessing,
      });
    }
    if (value != 'ACCPAYCREDIT' && value != 'Credit Note') {
      paymentStatusItem.push({
        name: 'Paid',
        value: InvoicePaymentStatus.AwaitingPayment,
      });
    }
    if (value == 'EXP' || value == 'Receipt') {
      this.isReceipt = true;
      this.invoice.paymentStatus = InvoicePaymentStatus.AwaitingPayment;
    }
    this.paymentStatusItem = paymentStatusItem;
  }
  ngOnInit() {
    this.subscriptions.push(this._userService.loggedUserDetails.subscribe(userdata => {
      if (userdata) {
        this.currentUser = userdata;
      } else {
        this.currentUser = [];
      }
    }));
    this.checkIfMobileDevice();
    this.setIsQuickBookOrNot();
    this.loadDisplaySettings();
    this.setIntegrationType(); // Initialize integration type for status pill
    this.getTaxRates();
    this.getOrganizationCurrencies();
    this.GetBankAcoountDetails();
    this.getOrganizationUsers();

    if (!this.isEditable) this.expanded = true;

    this.subscriptions.push(
      this._userService.loggedUserDetails.subscribe((data) => {
        if (data) {
          this.userDetails = data;
        } else {
          this.userDetails = [];
        }
      })
    );
    this.subscriptions.push(
      this._userService.userRole$.subscribe((data) => {
        this.userRole = data;
      })
    );
    this._userService
      .getCanPublish(this._organizationService.selectedOrganization, this.userDetails.id)
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.canPublish = response.canPublish;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
    this._organizationService
      .getOrganizationCountry(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.countryCode = response.countryCode;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );

    if (this.billsToPayMode) {
      this._recognizedInvoiceService.billsToPayInvoiceDetailsRequest$
        .pipe(this.untilThis)
        .subscribe(
          (requestData: BillsToPayInvoiceDetailsRequest) => {
            this.listOfSelectedRecords = requestData;
            this.isApproveButtonShown = !requestData?.isCompletedTask;
            this.returnBackToText = requestData.returnBackToText;
            //this.currentPannel = Pannels.DetailsTab;
            this.isSpinnerShown = true;
            this.loadingChanged.emit(true);
            // use forkJoin
            const invoice$ =
              this._invoiceService.getInvoiceDetailsForBillsToPay(requestData);
            const trackingCategories$ =
              this._organizationService.getOrganizationTrackingCategoriesWithOptions(
                this._organizationService.selectedOrganization
              );
            const accounts$ = this._bankAccountService.getPaymentAccounts(
              this._organizationService.selectedOrganization
            );
            const forkJoin$ = forkJoin({
              invoice: invoice$,
              categories: trackingCategories$,
              accounts: accounts$,
            });

            forkJoin$.subscribe(
              (data) => {
                if (data?.invoice.bsbNumber) {
                  if (data?.invoice.bsbNumber.length == 5) {
                    data.invoice.bsbNumber = `0${data.invoice.bsbNumber}`;
                  }
                  if (!data?.invoice.bsbNumber.includes('-')) {
                    data.invoice.bsbNumber =
                      data.invoice.bsbNumber.slice(0, 3) +
                      '-' +
                      data.invoice.bsbNumber.slice(3);
                  }
                }

                this.invoiceColorNumber = requestData.invoiceColorNumber;
                this.invoice = data.invoice;
                // Initialize raw input with the loaded amount
                if (this.invoice.amountDue !== undefined && this.invoice.amountDue !== null) {
                  this.amountDueRawInput = this.invoice.amountDue.toString();
                }
                this.bankAccount.BSBNumber = this.invoice.bsbNumber;
                this.bankAccount.accountNumber = this.invoice.accountNumber;
                this.newSupplier.name = this.invoice.supplierName;
                this.newSupplier.supplierId = this.invoice.supplierId;
                this.handleInvoiceType();
                this.getOrganizationCustomFields();

                this.setForm();
                this.isSpinnerShown = false;
                this.loadingChanged.emit(false);
                this.trackingCategories = data.categories;
                this.setSelectedOptions();
                this.getSelectedTaxRate();
                this.accounts = data.accounts;
                this.loadQBOClasses();
                this.loadQBOCustomers();
                // this.hexColorClass = this.suppliers.find(s => s.id === this.invoice.supplierId.toLowerCase())?.hexColorClass;
                this.invoice.paidBy =
                  data.invoice.paidBy != null
                    ? data.invoice.paidBy.toLowerCase()
                    : '';
                this.invoice.expenseReportId =
                  this.invoice.expenseReportId != null
                    ? data.invoice.expenseReportId.toLowerCase()
                    : null;
                if (
                  this.invoice.paidBy != null &&
                  this.users.length > 0 &&
                  this.users.find((p) => p.id == this.invoice.paidBy) != null
                ) {
                  this.getOrganizationExpClaims();
                }
                this.isNextDisabled = true;
                this.isPrevioustDisabled = true;
                //if (this.invoice.expenseReportId != null) {
                //  this.invoice.expenseReportName = this.expClaims.find(p => p.id == this.invoice.expenseReportId).reportName;
                //}
                if (this.orgTaxBasis != TaxBasis.IgnoreTax) {
                  if (this.invoice.invoiceLines?.length > 0) {
                    this.account = this.accounts.find(
                      (a) =>
                        a.id ===
                        this.invoice.invoiceLines[0].accountId?.toLowerCase()
                    );
                    if (!this.invoice?.invoiceLines[0]?.taxId) {
                      this.selectedTaxRateId = this.organizationTaxRateId;
                    } else {
                      this.selectedTaxRateId =
                        this.invoice.invoiceLines[0].taxId;
                    }
                  }
                } else {
                  this.taxRates = [];
                  this.taxRates.push(this.qboTaxDefault);
                  this.selectedTaxRateId = '0';
                  this.organizationTaxRateId = '0';
                }

                if (
                  this.invoice.amountCredited &&
                  this.invoice.amountCredited != 0
                ) {
                  this.invoice.amountDue -= this.invoice.amountCredited;
                }
                if (this.invoice.amountPaid && this.invoice.amountPaid != 0) {
                  // this.invoice.amountDue -= this.invoice.amountPaid;
                  this.amountDueRawInput = (this.invoice.amountDue - this.invoice.amountPaid).toString();
                }

                if (
                  !this.bankAccount.BSBNumber &&
                  !this.bankAccount.accountNumber
                ) {
                  this.paymentViewStateValue =
                    PaymentViewState.AddPaymentAccount;
                }

                this.isPageLoaded = true;
              },
              (e: Error) => {
                this.isSpinnerShown = false;
                this.loadingChanged.emit(false);
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.Error,
                  'Error',
                  e.message
                );
              }
            );
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    } else {
      this.getOrganizationDefaultCurrency();
      this.loadPaymentStatus();
      this.getTrackingCategories();
      this.setForm();
      this.getAccounts();
      this.subsribeToSupplierEvents();
      this.getSelectedTaxRate();
      this.subscribeToInvoiceUpdates();

      this.user = JSON.parse(this._userService.upUserDetails) as User;
      this.isKVPMenuItemShown = this.user.role == 1;
      this._inboxInvoicesStorage.getStatus(
        this.overlayMode ? this.currentInvoiceId : this._activatedRoute.snapshot.paramMap.get('id')
      );
      if(this.overlayMode){
      this._inboxInvoicesStorage.hasNextInvoices$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          this.isNextDisabled = !result;
        });

      this._inboxInvoicesStorage.hasPreviousInvoices$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          this.isPrevioustDisabled = !result;
        });
      }
      else {
        this.isNextDisabled = true;
        this.isPrevioustDisabled = true;
      }
    }
    if (this.currentPannel != undefined) {
      this.tabClick(this.currentPannel, true);
    } else {
      this.currentPannel = Pannels.DetailsTab;
    }
    this.invoice.required_Fields = true;
  }
  searchSuppliers(event) {
    if (event) {
      this.supplierSearchList = this.suppliers.filter((s) =>
        s.name.toLowerCase().includes(event.toLowerCase())
      );
    } else {
      this.supplierSearchList = this.suppliers;
    }
  }

  archiveInvoice() {
    const archivedInvoice = {
      organizationId: this._organizationService.selectedOrganization,
      invoiceId: this.invoice.id.toString(),
      archivedBy: this.user.id,
      archivedAt: new Date(),
      archived: true,
    } as ArchiveInvoice;

    this._invoiceService
      .archiveInvoice(archivedInvoice)
      .pipe(this.untilThis)
      .subscribe(
        () => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Success,
            'Success',
            'Document Archived'
          );
          this.reroutAfterPublishing();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  unarchiveInvoice() {
    const archivedInvoice = {
      organizationId: this._organizationService.selectedOrganization,
      invoiceId: this.invoice.id.toString(),
      archivedBy: null,
      archivedAt: null,
      archived: false,
    } as ArchiveInvoice;

    this._invoiceService
      .unarchiveInvoice(archivedInvoice)
      .pipe(this.untilThis)
      .subscribe(
        () => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Success,
            'Success',
            'Document Unarchived'
          );
          this._router.navigate(
            [`/inbox/editInvoice/${archivedInvoice.invoiceId}`],
            { replaceUrl: true }
          );
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  closeContactForm(invoiceId: string) {
    this.currentPannel = Pannels.DetailsTab;

    let requestData = {
      invoiceColorNumber: Math.random() * 6,
      invoiceId: invoiceId,
      organizationId: this._organizationService.selectedOrganization,
      reportId: null,
      supplierId: null,
    } as BillsToPayInvoiceDetailsRequest;

    this._recognizedInvoiceService.sendBillsToPayInvoiceDetailsRequest(
      requestData
    );
  }

  closeInvoicePreviewForm(invoiceId: string) {
    this.resetDateLoadingVars();
    this.currentPannel = Pannels.DetailsTab;
    this.isPreviewVisible = false;
  }

  closeInvoicePreviewWebForm(invoiceId: string) {
    this.resetDateLoadingVars();
    this.currentPannel = Pannels.DetailsTab;
    this.isPreviewVisibleWeb = false;
  }

  setIsQuickBookOrNot() {
    this.subscriptions.push(
      this._organizationService.organizationList.subscribe((data) => {
        const org = data?.find(
          (o) =>
            o.organisationID === this._organizationService.selectedOrganization
        );
        const wasQuickBook = this.IsQuickBook;
        this.IsQuickBook =
          org?.accountingIntegration === AccountingIntegration.QBO
            ? true
            : false;
        this.IsNoAccounting =
          org?.accountingIntegration === AccountingIntegration.None
            ? true
            : false;
        this.IsXero =
          org?.accountingIntegration === AccountingIntegration.xero
            ? true
            : false;
        if (!wasQuickBook && this.IsQuickBook && this.qboClasses.length === 0) {
          this.loadQBOClasses();
          this.loadQBOCustomers();
        }
      })
    );
  }

  subsribeToSupplierEvents() {
    this._sharedService.isVisibleSource.subscribe((isVisible) => {
      if (isVisible) {
        this.newSupplier = {
          organizationId: this._organizationService.selectedOrganization,
          name:
            this.currentSupplier.name == undefined
              ? this.invoice.supplierName
              : this.currentSupplier.name,
          taxNumber: this.invoice.invoiceNumber,
          defaultAccount: new PaymentAccount(),
          firstName: '',
          lastName: '',
          email: '',
          currency: CurrencyCode.AUD,
          accountName: '',
          bsb: '',
          accountNumber: '',
          supplierId: this.currentSupplier.id,
        };
        this._sharedService.sendExistingSupplier(this.newSupplier);
      }
    });
  }

  updateBankName(name: string) {
    this.bankName = name;
  }

  getTrackingCategories() {
    this._organizationService
      .getOrganizationTrackingCategoriesWithOptions(
        this._organizationService.selectedOrganization
      )
      .pipe(take(1))
      .subscribe((categories: TrackingCategory[]) => {
        this.trackingCategories = categories;
        this.setSelectedOptions();
      });
    this.loadQBOClasses();
    this.loadQBOCustomers();
  }

  getBankName(bsb: string) {
    this._invoiceService
      .getBankNameByBSB(bsb)
      .pipe(take(1))
      .subscribe((result) => {
        this.bankName = !!result.name ? result.name : '';
      });
  }

  onSelectCategory(event) {
    const index = this.selectedOptions.findIndex(
      (o) => o.trackingCategoryId === event.trackingCategoryId
    );

    if (index !== -1) {
      this.selectedOptions[index] = event;
      this.selectedOptions[index].trackingCategoryName = this._getCategoryName(
        event.trackingCategoryId
      );
      this.saveInvoiceWithDelay(
        this.selectedOptions[index].trackingCategoryName
      );
      return;
    }
    this.selectedOptions.push(event);
    this.selectedOptions[this.selectedOptions.length - 1].trackingCategoryName =
      this._getCategoryName(event.trackingCategoryId);
    this.saveInvoiceWithDelay(
      this.selectedOptions[this.selectedOptions.length - 1].trackingCategoryName
    );
  }

  onSelectQBOClass(event) {
    const classId = event ? event.id : null;
    const className = event ? event.name : null;
    this.selectedQBOClassId = classId;
    if (this.invoice) {
      (this.invoice as any).classId = classId;
      if (this.invoice.invoiceLines) {
        this.invoice.invoiceLines.forEach((line) => {
          line.classId = classId;
          line.className = className;
        });
      }
    }
    this.saveInvoiceWithDelay(event ? event.name : '');
  }

  loadQBOClasses() {
    if (!this.IsQuickBook) { return; }
    this._organizationService
      .getOrganizationQBOClasses(this._organizationService.selectedOrganization)
      .subscribe(
        (classes) => {
          this.qboClasses = classes || [];
          this.ensureInvoiceClassInList();
          const headerClassId = (this.invoice as any)?.classId as string | undefined;
          const lineClassId = this.invoice?.invoiceLines?.find((l) => !!l.classId)?.classId;
          this.selectedQBOClassId = headerClassId || lineClassId || null;
        },
        () => {
          this.qboClasses = [];
          this.ensureInvoiceClassInList();
          const lineClassId = this.invoice?.invoiceLines?.find((l) => !!l.classId)?.classId;
          this.selectedQBOClassId = lineClassId || null;
        }
      );
  }

  private ensureInvoiceClassInList() {
    const line = this.invoice?.invoiceLines?.find((l) => !!l.classId);
    if (!line?.classId) { return; }
    if (this.qboClasses.some((c) => c.id === line.classId)) { return; }
    this.qboClasses = [
      ...this.qboClasses,
      {
        id: line.classId,
        name: line.className || line.classId,
        active: true,
        fullyQualifiedName: line.className || line.classId,
      } as QBOClass,
    ];
  }

  onSelectQBOCustomer(event) {
    const customerId = event ? event.id : null;
    const customerName = event ? event.name : null;
    this.selectedCustomerId = customerId;
    if (this.invoice?.invoiceLines) {
      this.invoice.invoiceLines.forEach((line) => {
        line.customerId = customerId;
        line.customerName = customerName;
      });
    }
    this.saveInvoiceWithDelay(customerName || '');
  }

  loadQBOCustomers() {
    if (!this.IsQuickBook) { return; }
    this._organizationService
      .getOrganizationQBOCustomers(this._organizationService.selectedOrganization)
      .subscribe(
        (customers) => {
          this.customers = customers || [];
          this.ensureInvoiceCustomerInList();
          this.selectedCustomerId = this.invoice?.invoiceLines?.find((l) => !!l.customerId)?.customerId || null;
        },
        () => {
          this.customers = [];
          this.ensureInvoiceCustomerInList();
          this.selectedCustomerId = this.invoice?.invoiceLines?.find((l) => !!l.customerId)?.customerId || null;
        }
      );
  }

  private ensureInvoiceCustomerInList() {
    const line = this.invoice?.invoiceLines?.find((l) => !!l.customerId);
    if (!line?.customerId) { return; }
    if (this.customers.some((c) => c.id === line.customerId)) { return; }
    this.customers = [
      ...this.customers,
      {
        id: line.customerId,
        name: line.customerName || line.customerId,
        active: true,
      } as QBOCustomer,
    ];
  }

  initInvoiceLine() {
    if (this.invoice.invoiceLines.length < 2) {
      // Capture the existing single line first so we don't lose per-line values
      // (classId/customerId) it already carries when the selected* state is stale.
      const existing = this.invoice?.invoiceLines?.[0];
      const line = new InvoiceLine(
        this.invoice.organisationId ??
        this._organizationService.selectedOrganization,
        Guid.create().toString(),
        this.selectedTaxRateId,
        this.selectedOptions.map((item) => item.id),
        this.invoice?.amountDue,
        this.invoice?.totalTax,
        this.invoice?.subTotal,
        this.invoice.description,
        this.account.id === Guid.EMPTY ? null : this.account.id
      );
      line.classId = this.selectedQBOClassId || existing?.classId || null;
      line.className = existing?.className || null;
      line.customerId = this.selectedCustomerId || existing?.customerId || null;
      line.customerName = existing?.customerName || null;
      this.invoice.invoiceLines = [line];
      if (line.classId) {
        (this.invoice as any).classId = line.classId;
      }
    }
  }

  initCreditNoteLine() {
    // Rebuild fresh each call (save + publish) to avoid duplicate lines.
    this.lineItemList = [];
    const lines = this.invoice?.invoiceLines || [];
    if (lines.length > 1) {
      // Multi-line credit note: emit one credit-note line per invoice line so the
      // breakdown (and per-line customer) carries through to QBO/Xero (SD-1177).
      lines.forEach((line) => {
        this.lineItemList.push({
          description: line.description || this.invoice.invoiceNumber,
          trackingOptions: line.trackingOptions || [],
          unitAmount: (line.amountDue || 0) - (line.totalTax || 0),
          taxType: line.taxId || this.selectedTaxRateId,
          taxAmount: line.totalTax || 0,
          lineAmount: line.amountDue,
          accountCode: line.accountId,
          quantity: line.quantity || 1,
          customerId: line.customerId || null,
          classId: line.classId || null,
        });
      });
    } else {
      var item = {
        description:
          this.invoice?.description === undefined ||
            this.invoice?.description === null ||
            this.invoice?.description === ''
            ? this.invoice.invoiceNumber
            : this.invoice?.description,
        trackingOptions: this.selectedOptions.map((item) => item.id),
        unitAmount:
          this.invoice?.amountDue -
          (this.invoice?.totalTax === null ? 0 : this.invoice?.totalTax),
        taxType: this.selectedTaxRateId,
        taxAmount: this.invoice?.totalTax === null ? 0 : this.invoice?.totalTax,
        lineAmount: this.invoice.amountDue,
        accountCode: this.account.id === Guid.EMPTY ? null : this.account.id,
        quantity: 1,
        customerId: this.selectedCustomerId || this.invoice?.invoiceLines?.[0]?.customerId || null,
        classId: this.selectedQBOClassId || this.invoice?.invoiceLines?.[0]?.classId || null,
      };

      this.lineItemList.push(item);
    }
  }

  initReceiptLine() {
    if (this.invoice.invoiceLines.length < 2) {
      this.invoice.invoiceLines = [
        new InvoiceLine(
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization,
          Guid.create().toString(),
          this.selectedTaxRateId,
          this.selectedOptions.map((item) => item.id),
          this.invoice?.amountDue,
          this.invoice?.totalTax,
          this.invoice?.subTotal,
          this.invoice.description,
          this.account.id === Guid.EMPTY ? null : this.account.id
        ),
      ];
    }
  }
  updateTotals(invoiceTotals: InvoiceTotals) {
    Object.keys(invoiceTotals).forEach(
      (k) => (this.invoice[k] = invoiceTotals[k])
    );
    this.isTotalsShown = true;
    this.updateAmountDueFormControl(invoiceTotals.amountDue);
  }

  updateAmountDueFormControl(amountDue: number) {
    this.form.patchValue({
      amountDue: amountDue,
    });
    this.form.markAsUntouched();
  }

  // Store the last raw input for the amountDue field
  amountDueRawInput: string = '';
  updateCalculatedTotals(amountDue) {
    if (!this.billsToPayMode) {
      // If input is empty and invoice.amountDue exists, use that instead
      if ((!amountDue || amountDue === '') && this.invoice?.amountDue) {
        amountDue = this.invoice.amountDue.toString();
      }

      // Store the raw input so the field doesn't get cleared on partial expressions
      this.amountDueRawInput = amountDue;

      let input = amountDue;
      let evaluated = null;
      if (typeof input === 'string') {
        // Remove all characters except numbers, math operators, and decimal point
        const sanitized = input.replace(/[^0-9.+\-*/()]/g, '');
        // Only try to evaluate if the input looks like a valid math expression
        if (/^[0-9().+\-*/]+$/.test(sanitized)) {
          try {
            // eslint-disable-next-line no-new-func
            evaluated = this.evaluateExpression(sanitized);
            if (/^[0-9()./]+$/.test(evaluated)) {
              evaluated = parseFloat(evaluated)
            }
          } catch {
            evaluated = null;
          }
        }
      } else if (typeof input === 'number') {
        evaluated = input;
      }
      // If the result is a valid number, update the model
      if (typeof evaluated === 'number' && !isNaN(evaluated)) {
        if (evaluated < 0) evaluated = Math.abs(evaluated);
        this.invoice.amountDue = evaluated;
      } else {
        // If not valid, set to NaN so the field shows blank, but keep the raw input for display
        this.invoice.amountDue = NaN;
      }
      this.handleTotals();
      this.checkTaxAmount();
      // Mirror the total only once the invoice is known to be in the org's own currency.
      // This also runs when the form binds the total on load, before the org currency has
      // arrived -- showLocalCurrency is still its initial false then, and treating that as
      // "same currency" replaced a converted local amount with the foreign total.
      if (
        this.defaultCurrency &&
        this.invoice.currency === this.defaultCurrency &&
        typeof this.invoice.amountDue === 'number'
      )
        this.invoice.localCurrencyAmount = this.invoice.amountDue;
      // Update exchange rate when total changes and local currency is enabled
      if (
        this.showLocalCurrency &&
        this.invoice.localCurrencyAmount &&
        typeof this.invoice.amountDue === 'number' &&
        this.invoice.amountDue
      ) {
        this.exchangeRate = +(
          this.invoice.localCurrencyAmount / this.invoice.amountDue
        ).toFixed(4);
      }
    }
  }

  setForm() {
    // Initialize amountDueRawInput if invoice.amountDue exists
    // This ensures it's set every time the form is created
    if (this.invoice.amountDue !== undefined && this.invoice.amountDue !== null) {
      this.amountDueRawInput = this.invoice.amountDue.toString();
    }
    this.form = new FormGroup({
      type: new FormControl(this.invoice.type),
      date: new FormControl(this.invoice.date, [Validators.required]),
      dueDate: new FormControl(this.invoice.dueDate, [Validators.required]),
      supplier: new FormControl(this.invoice.supplierName, [
        Validators.required,
      ]),
      account: new FormControl(this.account?.name ? this.accountLabel(this.account) : null, [Validators.required]),
      invoiceNumber: new FormControl(this.invoice.invoiceNumber, [
        Validators.required,
        Validators.maxLength(this.IsQuickBook ? 21 : 250),
      ]),
      selectedTaxRate: new FormControl(this.selectedTaxRateId, [
        Validators.required,
      ]),
      currency: new FormControl(this.invoice.currency, [Validators.required]),
      amountDue: new FormControl(this.invoice.amountDue, [Validators.required]),
      paymentStatus: new FormControl(this.invoice.paymentStatus),
      paymentDate: new FormControl(this.invoice.paymentDate),
      paymentAccountNumber: new FormControl(this.invoice.paymentAccountNumber),
      paidBy: new FormControl(this.invoice.paidBy),
      expenseReportId: new FormControl(this.invoice.expenseReportId),
    });
  }

  getAccounts() {
    this._bankAccountService
      .getPaymentAccounts(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe((accounts: PaymentAccount[]) => {
        this.accounts = accounts;
        !!this.invoice?.invoiceLines[0]?.accountId
          ? (this.account = this.accounts.find(
            (a) =>
              a.id.toLowerCase() ===
              this.invoice.invoiceLines[0].accountId.toLowerCase()
          ))
          : this.updateAccount();
        this.updateSelectedAccountFormValue();
      });
  }

  stripHTML(HTMLText: string): string {
    const reg = /<[^>]+>/gi;
    return HTMLText.replace(reg, '');
  }

  getSuppliers() {
    this._suppliersService
      .getSuppliers(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe((suppliers: SupplierShort[]) => {
        this.suppliers =
          suppliers?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        this.suppliers.forEach((x) => (x.name = this.stripHTML(x.name)));
        this.supplierSearchList = this.suppliers;
        if (!!this.isEditable) {
          this.updateSupplierStatus();
          this.updateCurrentSupplier();
          !!this.invoice?.invoiceLines[0]?.accountId
            ? (this.account = this.accounts.find(
              (a) =>
                a.id.toLowerCase() ===
                this.invoice.invoiceLines[0].accountId.toLowerCase()
            ))
            : this.updateAccount();
          this.handleInvoiceCurrency();
        }
      });
  }

  subscribeToInvoiceUpdates() {
    this._recognizedInvoiceService.existingInvoiceState$
      .pipe(this.untilThis)
      .subscribe(
        (invoice: Invoice) => {
          // The inbox overlay reuses this same form instance across publish ->
          // next swaps (the bill is swapped in place rather than navigating to a
          // new route). The old full-page flow reset everything by recreating the
          // component on navigation; here we must do it ourselves. Treat each swap
          // as a clean load: clear the transient publish flags (otherwise
          // `loading` stays true and the Publish button is stuck on
          // "Publishing...") and reset the model + supplier so the new bill does
          // not inherit the previous bill's values (e.g. a stale supplierId that
          // leaves the wrong supplier name/logo in the header).
          if (this.overlayMode) {
            this.loading = false;
            this.isPublishing = false;
            this.isUpdateAfterPublish = false;
            this.showPublishValidation = false;
            this.invoice = new Invoice(
              this._organizationService.selectedOrganization
            );
            this.currentSupplier = new SupplierWithAlias();
            // setForm() (which seeds these from the bill) only runs once on init,
            // so clear the prior bill's amount mirror before the new one loads —
            // otherwise the stale value drives the Total and is read back into
            // invoice.amountDue, freezing the Totals on the previous bill.
            this.amountDueRawInput = '';
          }
          if (invoice.bsbNumber) {
            if (invoice.bsbNumber.length == 5) {
              invoice.bsbNumber = `0${invoice.bsbNumber}`;
            }
            invoice.bsbNumber = invoice.bsbNumber.replace('-', '');
            invoice.bsbNumber =
              invoice.bsbNumber.replace('-', '').slice(0, 3) + '-' + invoice.bsbNumber.slice(3);
          }
          if (invoice.accountNumber) {
            invoice.accountNumber = invoice.accountNumber.replace(' ', '');
          }
          if (invoice.accountNumberUS) {
            invoice.accountNumberUS = invoice.accountNumberUS.replace(' ', '');
          }
          Object.keys(invoice).forEach(
            (key) =>
            (this.invoice[key] =
              invoice[key] !== null ? invoice[key] : this.invoice[key])
          );
          // In the inbox overlay the form stays mounted across prev/next swaps,
          // so refresh the prev/next disabled state for the newly loaded bill.
          if (this.overlayMode) {
            this._inboxInvoicesStorage.getStatus(this.invoice.id?.toString());
          }
          this.currentTotalTax = invoice.totalTax;
          this.handleInvoiceType();
          this.GetApprovalAssignDetail();

          if (this.invoice.invoiceLines?.length > 0) {
            if (!this.invoice?.invoiceLines[0]?.taxId) {
              this.selectedTaxRateId = this.organizationTaxRateId;
            } else {
              this.selectedTaxRateId = this.invoice.invoiceLines[0].taxId;
            }
          }

          if (this.orgTaxBasis != TaxBasis.IgnoreTax) {
            if (this.invoice.invoiceLines?.length > 0) {
              if (!this.invoice?.invoiceLines[0]?.taxId) {
                this.selectedTaxRateId = this.organizationTaxRateId;
              } else {
                this.selectedTaxRateId = this.invoice.invoiceLines[0].taxId;
              }
            }
          } else {
            this.taxRates = [];
            this.taxRates.push(this.qboTaxDefault);
            this.selectedTaxRateId = '0';
            this.organizationTaxRateId = '0';
          }

          this.handleInvoiceLines();
          this.handleRecognizedDates();
          this.handleTotals();
          if (!!this.isEditable) {
            this.handleRecognizedSupplier();
            this.updateCurrentSupplier();
            this.updateAccount();
            this.showRefTooltip = false;
            this.checkDuplicate();
          }

          this.setValuesForOneLine();
          // this.hexColorClass = this.suppliers.find(s => s.id === this.invoice.supplierId)?.hexColorClass;
          this.supplierName = this.currentSupplier.name
            ? this.currentSupplier.name.split(' ')[0]
            : invoice.supplierName != null
              ? invoice.supplierName.split(' ')[0]
              : '';
          if (!!this.invoice.supplierId) {
            this.getBankAccountDetailsBySupplierId(
              this.invoice.supplierId,
              this.invoice.supplierName
            );
          }
          else if (
            (this.invoice.bsbNumber && this.invoice.accountNumber) ||
            (this.invoice.routingNumber && this.invoice.accountNumberUS)
          ) {
            this.bankAccount.BSBNumber = this.invoice.bsbNumber;
            this.bankAccount.accountNumber = this.invoice.accountNumber;
            this.bankAccount.branchDetails = this.invoice.bsbNumber;
            this.bankAccount.routingNumber = this.invoice.routingNumber;
            this.bankAccount.accountNumberUS = this.invoice.accountNumberUS;
            this.paymentViewStateValue = PaymentViewState.SaveNewValues;
            this.warningIsReadyToBeShown = true;
          }
          else {
            this.paymentViewStateValue = PaymentViewState.AddPaymentAccount;
          }

          if (this.invoice.invoiceLines?.length > 1) {
            this.updateAmountDueFormControl(invoice.amountDue);
            this.updateSelectedTaxRateFormValue(this.selectedTaxRateId);
          }

          // Overlay reuses the form across publish -> next swaps without re-running
          // setForm(), so re-seed the amount mirror and patch the amountDue control
          // to the freshly loaded bill. Without this the Totals (Net Amount / Tax /
          // Total) stay frozen on the previous bill's amount.
          if (this.overlayMode) {
            this.amountDueRawInput =
              this.invoice.amountDue !== null && this.invoice.amountDue !== undefined
                ? this.invoice.amountDue.toString()
                : '';
            this.updateAmountDueFormControl(this.invoice.amountDue);
            this.updateSelectedTaxRateFormValue(this.selectedTaxRateId);
          }

          if (this.invoice.paymentStatus) {
            this.invoice.paymentStatus = this.paymentStatusItem?.find(
              (x) => x.value == this.invoice.paymentStatus
            )?.value;
          } else {
            this.invoice.paymentStatus = this.paymentStatusItem?.find(
              (x) => x.value == InvoicePaymentStatus.AwaitingProcessing
            )?.value;
          }

          if (this.invoice.invoiceLines.length > 0) {
            if (this.invoice.invoiceLines[0]?.accountId) {
              this.account = this.accounts.find(
                (a) =>
                  a.id.toLowerCase() ===
                  this.invoice.invoiceLines[0].accountId.toLowerCase()
              );
            } else {
              this.updateAccount();
            }
          }

          this.invoiceColorNumber =
            (this._inboxInvoicesStorage.getInvoiceArrayIndex(
              this.invoice.id.toString()
            ) %
              6) +
            1;
          this.isSpinnerShown = false;
          this.handleInvoiceCurrency();
          this.readonlySupplierField = this.invoice.supplierName ? true : false;

          this.isExpClaim =
            this.invoice.type.toString() === 'EXPCLAIMS' ? true : false;
          this.isReceipt =
            this.invoice.type.toString() === 'EXP' ? true : false;
          if (this.isExpClaim) {
            setTimeout(() => {
              this.handleExpClaimDetails();
            }, 400);
          }
          if (this.invoice.paymentDate == null) {
            this.invoice.paymentDate = stringToDate(invoice.transactionDate);
          }
          if (invoice.paymentAccountNumber != null) {
            this.invoice.paymentAccountNumber =
              invoice.paymentAccountNumber.toLowerCase();
            this.updatePaymentAccount();
          }
          if (
            this.invoice.unreconciledReportId != null &&
            this.invoice.unreconciledReportId != ''
          ) {
            this.isReportWarningShown = true;
          }
          if (this.invoice.supplierName == '') {
            this.invoice.supplierName = null;
          }
          if (this.invoice.paymentAccountNumber == '') {
            this.invoice.paymentAccountNumber = null;
          }
          this.isPageLoaded = true;
          this.calculateDivHeight();
          if (!this.invoice.processed) {
            this.form.valueChanges.subscribe((values) => {
              this.invoice.required_Fields = !this.form.invalid;
            });
          }
          this.getOrganizationCustomFields();
          if (this.currentSelectedMatch != "") {
            this.changeSelectedMatch(false, this.currentSelectedMatch);
          }
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
          this.isSpinnerShown = false;
        }
      );
  }

  doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    try {
      xhr.send();
      if (xhr.status == 404) {
        return false;
      } else {
        return true;
      }
    } catch {
      return false;
    }
  }

  handleExpClaimDetails() {
    this.invoice.dueDate = this.invoice.date;
    this.invoice.paidBy = this.invoice.paidBy?.toLowerCase();
    if (
      this.invoice.paidBy != null &&
      this.users.length > 0 &&
      this.users.find((p) => p.id == this.invoice.paidBy) != null
    ) {
      this.invoice.paidByName = this.users.find(
        (p) => p.id == this.invoice.paidBy
      ).name;
      this.getOrganizationExpClaims();
    }
    if (
      this.invoice.expenseReportId != null &&
      this.expClaims.length > 0 &&
      this.expClaims.find((p) => p.id == this.invoice.expenseReportId) != null
    ) {
      this.invoice.expenseReportName = this.expClaims.find(
        (p) => p.id == this.invoice.expenseReportId
      ).reportName;
    }
  }

  setValuesForOneLine() {
    if (!!this.invoice?.invoiceLines[0]?.accountId)
      this.account = this.accounts.find(
        (a) => a.id === this.invoice.invoiceLines[0].accountId
      );
    this.invoice.description =
      this.invoice.invoiceLines[0]?.description ?? this.invoice.description;
    this.setSelectedOptions();
  }

  setSelectedOptions() {
    if (this.invoice.invoiceLines[0]?.trackingOptions?.length > 0) {
      for (let i = 0; i < this.invoice.invoiceLines[0]?.trackingOptions?.length; i++) {
        const category = this.trackingCategories.find((c) =>
          c.options.some(
            (o) => o.id === this.invoice.invoiceLines[0]?.trackingOptions[i]
          )
        );
        this.selectedOptions[i] = category?.options.find(
          (o) => o.id === this.invoice.invoiceLines[0]?.trackingOptions[i]
        );
        if (
          this.selectedOptions[i]?.name != null &&
          this.selectedOptions[i]?.name != ''
        ) {
          this.selectedTrackingCategories[i] = this.selectedOptions[i]?.name;
        }
        else {
          this.selectedTrackingCategories[i] = null;
        }
      }
    }
    else {
      this.selectedTrackingCategories[0] = null;
    }
  }

  checkDuplicate() {
    if (!!this.invoice.isDuplicate && this.isEditable){
      this.isDuplicateWarningShown = true;
    }
    else{
      this.isDuplicateWarningShown = false;
    }
  }

  deleteInvoice() {
    // Captured BEFORE the request, because reroutAfterPublishing below advances this.invoice to
    // the next bill. Reading the id after that point — or letting the parent fall back to its
    // overlayInvoiceId, which has also moved on — identified the wrong invoice, so the row that
    // disappeared from the table was the NEXT one while the deleted one stayed on screen.
    const deletedId = this.invoice.id?.toString();
    this._invoiceService
      .deleteInvoice(deletedId)
       .pipe(this.untilThis)
       .subscribe(
         () => {
           this.reroutAfterPublishing(true);
           // Emit the id explicitly rather than relying on the parent to infer which invoice
           // this was: by now the overlay is showing a different one.
           this.onDeleteDocument.emit(deletedId);
         },
         (e: Error) => {
           this._toasterMessageService.displayToasterState(
             ToasterTypes.Error,
             'Error',
             e.message
           );
         }
       );
  }

  showDeleteInvoiceConfirmation() {
    this._confirmationDialogService
      .confirm('Confirm', 'Do you want to delete the invoice?', 'Yes', 'No', '')
      .then((confirm) => {
        if (confirm) {
          this.deleteInvoice();
        }
      });
  }

  getBankAccountDetailsBySupplierId(supplierId: string, supplieName: string) {
    this._bankAccountService
      .getBankAccountBySupplierId(
        supplierId,
        this._organizationService.selectedOrganization
      )
      .pipe(take(1))
      .subscribe((data) => {
        if (!!data) {
          Object.keys(data).forEach(
            (k) =>
              (this.bankAccount[k] = !!data[k] ? data[k] : this.bankAccount[k])
          );
          this.bankAccount.contactId = supplierId;
          this.bankAccount.accountName = supplieName;

          if (this.countryCode == 'AU') {
            this.bankAccount.BSBNumber = this.bankAccount.branchDetails
              ? this.bankAccount.branchDetails.includes('-')
                ? this.bankAccount.branchDetails
                : this.bankAccount.branchDetails?.slice(0, 3) +
                '-' +
                this.bankAccount.branchDetails?.slice(3)
              : null;
            this._bankAccountService.updateBankAccount(this.bankAccount);
            this.getBankName(
              this.bankAccount.branchDetails?.slice(0, 3) +
              '-' +
              this.bankAccount.branchDetails?.slice(3)
            );

            if (
              !this.invoice?.bsbNumber &&
              !this.invoice.accountNumber &&
              !this.bankAccount.BSBNumber &&
              !this.bankAccount.accountNumber
            ) {
              this.paymentViewStateValue = PaymentViewState.AddPaymentAccount;
            }

            // If existing record for contact in the ‘Bank Accounts’ table
            if (this.bankAccount.BSBNumber && this.bankAccount.accountNumber) {
              if (this.invoice.bsbNumber && this.invoice.accountNumber) {
                if (
                  this.bankAccount.BSBNumber == this.invoice.bsbNumber &&
                  this.bankAccount.accountNumber == this.invoice.accountNumber
                ) {
                  this.paymentViewStateValue = PaymentViewState.SameValues;
                } else {
                  this.paymentViewStateValue = PaymentViewState.DifferentValues;
                }
              } else {
                this.paymentViewStateValue = PaymentViewState.HideWarning;
              }
            } else {
              // If not an existing record for contact in the ‘Bank Accounts’ table
              if (this.invoice.bsbNumber && this.invoice.accountNumber) {
                this.paymentViewStateValue = PaymentViewState.SaveNewValues;
                // this.bankAccount.BSBNumber = this.invoice.bsbNumber;
                // this.bankAccount.accountNumber = this.invoice.accountNumber;
                // this.bankAccount.branchDetails = this.invoice.bsbNumber;
              }
            }
          } else if (this.countryCode == 'US') {
            this._bankAccountService.updateBankAccount(this.bankAccount);
            // this.getBankName(this.bankAccount.branchDetails?.slice(0, 3) + '-' + this.bankAccount.branchDetails?.slice(3));

            if (
              !this.invoice?.routingNumber &&
              !this.invoice.accountNumberUS &&
              !this.bankAccount.routingNumber &&
              !this.bankAccount.accountNumberUS
            ) {
              this.paymentViewStateValue = PaymentViewState.AddPaymentAccount;
            }

            // If existing record for contact in the ‘Bank Accounts’ table
            if (
              this.bankAccount.routingNumber &&
              this.bankAccount.accountNumberUS
            ) {
              if (this.invoice.routingNumber && this.invoice.accountNumberUS) {
                if (
                  this.bankAccount.routingNumber ==
                  this.invoice.routingNumber &&
                  this.bankAccount.accountNumberUS ==
                  this.invoice.accountNumberUS
                ) {
                  this.paymentViewStateValue = PaymentViewState.SameValues;
                } else {
                  this.paymentViewStateValue = PaymentViewState.DifferentValues;
                }
              } else {
                this.paymentViewStateValue = PaymentViewState.HideWarning;
              }
            } else {
              // If not an existing record for contact in the ‘Bank Accounts’ table
              if (this.invoice.routingNumber && this.invoice.accountNumberUS) {
                this.paymentViewStateValue = PaymentViewState.SaveNewValues;
                // this.bankAccount.routingNumber = this.invoice.routingNumber;
                // this.bankAccount.accountNumberUS = this.invoice.accountNumberUS;
                // this.bankAccount.branchDetails = this.invoice.routingNumber;
              }
            }
          }
          this.warningIsReadyToBeShown = true;
        } else {
          if (this.countryCode == 'US') {
            if (this.invoice.routingNumber && this.invoice.accountNumberUS) {
              // this.bankAccount.routingNumber = this.invoice.routingNumber;
              // this.bankAccount.accountNumberUS = this.invoice.accountNumberUS;
              // this.bankAccount.branchDetails = this.invoice.routingNumber;
              this.paymentViewStateValue = PaymentViewState.SaveNewValues;
              this.warningIsReadyToBeShown = true;
            } else {
              this.paymentViewStateValue = PaymentViewState.AddPaymentAccount;
              this.bankAccount.accountNumberUS = '';
              this.bankAccount.routingNumber = '';
            }
          } else {
            if (this.invoice.bsbNumber && this.invoice.accountNumber) {
              // this.bankAccount.BSBNumber = this.invoice.bsbNumber;
              // this.bankAccount.accountNumber = this.invoice.accountNumber;
              // this.bankAccount.branchDetails = this.invoice.bsbNumber;
              this.paymentViewStateValue = PaymentViewState.SaveNewValues;
              this.warningIsReadyToBeShown = true;
            } else {
              this.paymentViewStateValue = PaymentViewState.AddPaymentAccount;
              this.bankAccount.accountNumber = '';
              this.bankAccount.BSBNumber = '';
              this.bankAccount.branchDetails = '';
            }
          }
        }
      });
  }

  updateBankAccount(account: BankAccount, countryCode: string) {
    const updatedAccount = JSON.parse(JSON.stringify(account));
    if (countryCode == 'US') {
      updatedAccount.routingNumber = account.routingNumber;
      updatedAccount.branchDetails = account.routingNumber.replace('-', '');
    } else {
      updatedAccount.BSBNumber = account.BSBNumber;
      updatedAccount.branchDetails = account.BSBNumber.replace('-', '');
    }
    if (!updatedAccount.contactId)
      updatedAccount.contactId = this.invoice.supplierId;

    this._organizationService
      .UpdateBankAccount(updatedAccount)
      .pipe(take(1))
      .subscribe(
        () => {
          this.warningIsReadyToBeShown = false;
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Success,
            'Success',
            'Bank Account Updated!'
          );
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  updateAccount() {
    if (!this.account?.name) {
      const code = this.suppliers.find(
        (s) => s.id === this.invoice.supplierId
      )?.defaultAccountCode;
      let accountFind = this.accounts.find((x) => x.code == code);
      if (accountFind) {
        this.account = accountFind as PaymentAccount;
      } else {
        this.account = new PaymentAccount();
      }

      if (this.account?.name == '') {
        this.account.name = null;
      }
    }
    else {
      this.updateSelectedAccountFormValue();
    }
  }

  handleTotals() {
    const rate = this.getTaxRateById(this.selectedTaxRateId);

    if (rate === 0) {
      this.invoice.subTotal = this.invoice.amountDue;
      if (this.invoice.invoiceLines.length < 2) {
        this.invoice.invoiceLines.forEach((u) => {
          u.totalTax = 0;
        });
      }
      this.invoice.totalTax = sumOfArrayByProperty(
        this.invoice.invoiceLines,
        'totalTax'
      );
      this.checkTaxAmount();
    } else if (rate > 0) {
      if (this.invoice.invoiceLines.length == 1)
        this.invoice.invoiceLines[0].amountDue = this.invoice.amountDue;
      this.invoice.invoiceLines.forEach((u) => {
        //u.amountDue = this.invoice.amountDue;
        u.totalTax = round(
          Math.abs(u.amountDue) - (100 * Math.abs(u.amountDue)) / (100 + rate)
        );
      });
      if (this.invoice?.amountDue < 0) {
        this.invoice.amountDue = Math.abs(this.invoice?.amountDue);
      }
      this.invoice.totalTax = sumOfArrayByProperty(
        this.invoice.invoiceLines,
        'totalTax'
      );
      this.invoice.subTotal = round(
        this.invoice?.amountDue - this.invoice.totalTax
      );
      // if (this.selectedExclusivTaxRateId == null || this.selectedExclusivTaxRateId == "-1") {
      //this.invoice.subTotal = round((this.invoice?.amountDue * 100) / (100 + rate));
      // }
      this.checkTaxAmount();
    } else {
      this.invoice.totalTax = 0;
    }
  }

  updateTaxRate(id: string) {
    this.selectedTaxRateId = id;
    this.handleTotals();
  }

  handleRecognizedSupplier() {
    this.isLoaded = true;
    this.updateSupplierStatus();
    this.isLoaded = false;
  }

  handleSupplierName(event) {
    this.newSupplier.name = event;
    const matchedSupplier = this.suppliers?.filter(
      (s) => s.name == this.newSupplier.name
    );

    if (matchedSupplier?.length == 0 && event) {
      this.isCreateSupplierItemShown = true;
    } else if (!event) {
      this.handleSupplierBlur();
    } else {
      this.isCreateSupplierItemShown = false;
    }
  }

  handleSupplierBlur() {
    this.newSupplier.name = this.invoice.supplierName;
    this.isCreateSupplierItemShown = this.isNewSupplier;
  }

  createNewSupplier() {
    if (!this.creatingNewSupplier) {
      this.creatingNewSupplier = true;
      this.addNewSupplier(this.newSupplier, false);
    }
  }

  updateSupplierStatus() {
    if (this.invoice.supplierName != null && this.invoice.supplierName != '') {
      const supplier = tryGetObjectByProperty(
        this.suppliers,
        'name',
        this.invoice.supplierName
      ) as SupplierShort;
      this.isNewSupplierLoaded = supplier ? true : false;
      this.isNewSupplier = !supplier && !this.invoice.supplierId ? true : false;
      this.isCreateSupplierItemShown = this.isNewSupplier;
      this.newSupplier.name = this.invoice.supplierName;
      this.invoice.supplierId = supplier?.id ?? this.invoice.supplierId;
    }
  }

  handleRecognizedDates() {
    this.invoice.date = stringToDate(this.invoice.date);
    if (!this.invoice.dueDate) {
      this.invoice.dueDate = this.invoice.date;
    } else {
      this.invoice.dueDate = stringToDate(this.invoice.dueDate);
    }
  }

  onSelectSupplier(event: SupplierShort) {
    this.isLoaded = true;
    this.isNewSupplierLoaded = true;
    this.isAccountWarningShown = false;
    if (event == undefined) {
      this.isNewSupplier = true;
      return;
    }
    this.isNewSupplier = false;
    this.isCreateSupplierItemShown = this.isNewSupplier;
    this.isAliasWarningShown = !!this.currentSupplier.id ? false : true;
    this.invoice.supplierId = event.id;
    this.invoice.supplierName = event.name;
    this.getBankAccountDetailsBySupplierId(
      this.invoice.supplierId,
      this.invoice.supplierName
    );
    this.updateCurrentSupplier();

    const supplierCurrencyCode = Object.values(CurrencyCode).find(
      (v) => v.toString() == event.defaultCurrency
    );
    this.invoice.currency = supplierCurrencyCode ?? this.defaultCurrency;
    // this.updateAccount();

    this.saveInvoiceWithDelay('Supplier');
  }

  saveInvoiceWithDelay(fieldName: string, delay: number = 500) {
    if (!this.invoice.processed) {
      setTimeout(() => {
        this.save(fieldName);
      }, delay);
    }
  }

  onSelectAccount(event: PaymentAccount) {
    if (event == undefined) {
      let data = {
        code: null,
        displayCode: null,
        id: null,
        name: null,
        accountID: null,
        isActive: true,
      };
      this.account = data;
      this.saveInvoiceWithDelay('Account');
      return;
    }
    let data = {
      code: event.code,
      displayCode: event.displayCode,
      id: event.id,
      name: event.name,
      accountID: event.id,
      isActive: event.isActive,
    };
    this.account = data;
    const supplier = this.suppliers?.find(
      (s) => s.id == this.currentSupplier?.id
    );
    this.isAccountWarningShown =
      this.currentSupplier?.id && !supplier?.defaultAccountCode ? true : false;
    this.saveInvoiceWithDelay('Account');
  }

  onCodingSuggestionApplied(event: PaymentAccount) {
    if (!event) {
      return;
    }

    this.form?.get('account')?.setValue(event);
    this.onSelectAccount(event);
  }

  onCodingSuggestionCopied(payload: AccountCodingCopyPayload) {
    if (!payload?.lines?.length) {
      return;
    }

    const lineEntries = payload.lines.filter((line) => !!line.accountId || !!line.accountName);
    if (!lineEntries.length) {
      return;
    }

    const targetTotalRaw = this.invoice?.amountDue ?? payload.totalAmount;
    const baseTotal = lineEntries.reduce((sum, line) => sum + (line.amountDue ?? 0), 0);
    let targetTotal =
      typeof targetTotalRaw === 'number' && !isNaN(targetTotalRaw)
        ? targetTotalRaw
        : baseTotal;

    if (!targetTotal || isNaN(targetTotal)) {
      targetTotal = baseTotal;
    }

    const lineCount = lineEntries.length;
    let runningTotal = 0;
    const rate = this.getTaxRateById(this.selectedTaxRateId);
    let totalTax = 0;

    const nextLines = lineEntries.map((line, index) => {
      const resolvedAccount = this.resolveAccountForCoding(line.accountId, line.accountName);
      const baseAmount = line.amountDue ?? 0;
      let proratedAmount = 0;

      if (baseTotal > 0) {
        proratedAmount = round((baseAmount / baseTotal) * targetTotal);
      } else {
        proratedAmount = round(targetTotal / lineCount);
      }

      if (index === lineCount - 1) {
        proratedAmount = round(targetTotal - runningTotal);
      }

      let lineTax = 0;
      let lineSubTotal = proratedAmount;
      if (rate && rate > 0) {
        lineTax = round(
          Math.abs(proratedAmount) - (100 * Math.abs(proratedAmount)) / (100 + rate)
        );
        lineSubTotal = round(proratedAmount - lineTax);
      }

      runningTotal += proratedAmount;
      totalTax += lineTax;

      return new InvoiceLine(
        this.invoice.organisationId ?? this._organizationService.selectedOrganization,
        Guid.create().toString(),
        this.selectedTaxRateId,
        this.selectedOptions.map((item) => item.id),
        proratedAmount,
        lineTax,
        lineSubTotal,
        this.invoice.description,
        resolvedAccount?.id ?? null,
        1
      );
    });

    const updatedTotals = new InvoiceTotals(
      targetTotal,
      totalTax,
      round(targetTotal - totalTax)
    );

    this.updateInvoiceLines({
      invoiceLines: nextLines,
      invoiceTotals: updatedTotals,
    });
  }

  private resolveAccountForCoding(accountId?: string, accountName?: string) {
    if (accountId) {
      const match = this.accounts?.find((acc) => acc.id === accountId || acc.accountID === accountId);
      if (match) {
        return match;
      }
    }

    if (accountName) {
      const lowered = accountName.toLowerCase();
      const match = this.accounts?.find((acc) => acc.name?.toLowerCase?.() === lowered);
      if (match) {
        return match;
      }
    }

    return null;
  }

  onSelectType(eventValue: string) {
    this.type = eventValue; // == "0: ACCPAY" ? "ACCPAY" : (eventValue == "1: ACCPAYCREDIT" ? "ACCPAYCREDIT" : "EXPCLAIMS");
    this.invoice.type =
      this.type === 'ACCPAYCREDIT'
        ? DocumentType['Credit Note']
        : this.type === 'ACCPAY'
          ? DocumentType['Supplier Invoice']
          : this.type === 'ACCREC'
            ? DocumentType['Customer Invoice']
            : this.type === 'EXP'
              ? DocumentType['Receipt']
              : DocumentType['Expense Claim'];

    this.isExpClaim = false;
    this.isReceipt = false;
    if (eventValue === 'EXPCLAIMS') {
      this.invoice.dueDate = this.invoice.date;
      this.isExpClaim = true;
      this.invoice.paidBy = this.userDetails.id.toLowerCase();
    }
    if (eventValue === 'EXP') {
      this.invoice.dueDate = this.invoice.date;
      this.isReceipt = true;
      this.invoice.paymentStatus = this.paymentStatusItem?.find(
        (x) => x.value == InvoicePaymentStatus.Paid
      )?.value;
    }
    this.paymentStatusItem = [];

    this.setFormValidator(eventValue);

    this.loadPaymentStatus(eventValue);
    this.saveInvoiceWithDelay('Type');
  }

  setFormValidator(type: string) {
    if (this.form) {
      this.form.get('paymentDate').clearValidators();
      this.form.get('paymentAccountNumber').clearValidators();
      this.form.get('paidBy').clearValidators();
      this.form.get('expenseReportId').clearValidators();
      this.form.get('dueDate').clearValidators();
      if (type === 'ACCPAY' || type === 'ACCREC') {
        if (
          this.invoice.paymentStatus == InvoicePaymentStatus.AwaitingPayment ||
          this.invoice.paymentStatus == InvoicePaymentStatus.Paid
        ) {
          this.form.get('paymentDate').setValidators([Validators.required]);
          this.form
            .get('paymentAccountNumber')
            .setValidators([Validators.required]);
        }
        this.form.get('dueDate').setValidators([Validators.required]);
      } else if (type === 'EXPCLAIMS') {
        this.form.get('paymentDate').clearValidators();
        this.form.get('paidBy').setValidators([Validators.required]);
        this.form.get('expenseReportId').setValidators([Validators.required]);
      } else if (type === 'EXP') {
        this.form
          .get('paymentAccountNumber')
          .setValidators([Validators.required]);
      }
      this.form.get('paymentDate').updateValueAndValidity();
      this.form.get('paymentAccountNumber').updateValueAndValidity();
      this.form.get('dueDate').updateValueAndValidity();
      this.form.get('paidBy').updateValueAndValidity();
      this.form.get('expenseReportId').updateValueAndValidity();
    }
  }
  addDefaultAccount(noAlert: any) {
    this.addDefaultAccountLoading = true;
    const account = new SupplierAccountCreated(
      this.currentSupplier.id,
      this.currentSupplier.name,
      this._organizationService.selectedOrganization,
      this.account.code
    );

    this._suppliersService
      .addDefaultAccount(account)
      .pipe(take(1))
      .subscribe(
        () => {
          if (noAlert === false) {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Success,
              'Success',
              'Added!'
            );
            this.toggleAccountWarning();
            this.addDefaultAccountLoading = false;
          }
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
          this.addDefaultAccountLoading = false;
        }
      );
  }

  updateSupplier(name: string) {
    const supplier = tryGetObjectByProperty(
      this.suppliers,
      'name',
      name
    ) as SupplierShort;
    this.isLoaded = true;
    this.isNewSupplierLoaded = true;
    if (!supplier) {
      this.isNewSupplier = true;
      this.invoice.supplierId = null;
      this.newSupplier.name = name;
    } else {
      this.isAliasWarningShown = !!this.currentSupplier.id ? false : true;
      this.isNewSupplier = false;
      this.isCreateSupplierItemShown = false;
      this.invoice.supplierId = supplier.id;
      this.updateCurrentSupplier();
    }
  }

  updateCurrentSupplier() {
    this.currentSupplier.id = !!this.invoice.supplierId
      ? this.invoice.supplierId
      : this.currentSupplier?.id;
    this.currentSupplier.name = this.suppliers.find(
      (s) => s.id === this.currentSupplier.id
    )?.name;
    this.currentSupplier.alias = !this.currentSupplier.alias
      ? this.invoice.supplierName
      : this.currentSupplier.alias;
    // this.hexColorClass = this.suppliers.find(s => s.id === this.currentSupplier.id)?.hexColorClass;
  }

  updatePaymentAccount() {
    if (
      this.invoice.paymentAccountNumber != null &&
      this.bankAccountList.length > 0
    ) {
      this.MyBankAccount = !!this.invoice.paymentAccountNumber
        ? (tryGetObjectByProperty(
          this.bankAccountList,
          'accountID',
          this.invoice.paymentAccountNumber
        ) as PaymentAccount)
        : new PaymentAccount();
      if (this.MyBankAccount?.name == '') {
        this.MyBankAccount.name = null;
        this.invoice.paymentAccountNumber = null;
      }
      if (!this.MyBankAccount) this.invoice.paymentAccountNumber = null;
    }
  }

  addNewSupplier(
    supplier: NewSupplier,
    setInvoiceSupplierName: boolean = true
  ) {
    supplier.bankAccountRequestModel = null;
    supplier.name = setInvoiceSupplierName
      ? this.invoice.supplierName
      : supplier.name;
    const name = JSON.parse(JSON.stringify(supplier.name));
    const newSupplier = JSON.parse(JSON.stringify(supplier));
    newSupplier.bsb = newSupplier.bsb?.replace('-', '');
    newSupplier.currency = this.defaultCurrency;
    newSupplier.IsSupplier = true;
    newSupplier.OrganizationId = this._organizationService.selectedOrganization;
    newSupplier.hexColorClass = 'sup_img_box_' + this.invoiceColorNumber;
    if (!newSupplier.defaultAccount.id) newSupplier.defaultAccount = null;
    this.creatingNewSupplier = true;
    newSupplier.groupId = null;
    this._suppliersService
      .createSupplier(newSupplier)
      .pipe(this.untilThis)
      .subscribe((result) => {
        if (result?.supplierId == 'ConnectionLost') {
          if (this.IsQuickBook) {
            this._organizationService.getIntegrationCredentials('qbo').subscribe((res) => {
              if (res) {
                this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.ErrorWithHtml,
                  null,
                  `QuickBooks connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                );
              }
            });
          } else {
            this._organizationService.getIntegrationCredentials('xero').subscribe((res) => {
              if (res) {
                this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.ErrorWithHtml,
                  null,
                  `Xero connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                );
              }
            });
          }
        } else if (result?.message !== undefined) {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            null,
            result?.message
          );
          this.isNewSupplier = false;
          this.creatingNewSupplier = false;
          this.isCreateSupplierItemShown = false;
          this.isAliasWarningShown = false;
          const refField = document.getElementById('refField');
          refField.focus();
          this.loading = false;
        } else {
          this.invoice.supplierId = result.supplierId;
          this.suppliers = [
            ...this.suppliers,
            {
              id: result.supplierId,
              name: supplier.name,
              defaultAccountCode: supplier?.defaultAccount.code,
            },
          ];
          this.isNewSupplier = false;
          this.creatingNewSupplier = false;
          this.isCreateSupplierItemShown = false;
          const refField = document.getElementById('refField');
          this.invoice.supplierName = name;
          refField.focus();
          this.updateCurrentSupplier();
          this.updateSupplierStatus();
          this.save('Supplier');
          if (this.isPublishing) {
            this.submit();
          } else {
            if ((this.invoice.invoiceLines.length > 0 && this.invoice.invoiceLines[0].accountId == "")) {
              this.account = supplier?.defaultAccount;
              if (supplier?.defaultAccount?.name == '') {
                supplier.defaultAccount.name = null;
              }
              this.isAliasWarningShown = false;
              this.getBankAccountDetailsBySupplierId(
                this.invoice.supplierId,
                this.invoice.supplierName
              );
            }

            $('.ng-dropdown-panel').remove();
            $('#ddlsupplier').removeClass('ng-select-opened');
          }
        }
      });
  }
  isUpdateAfterPublish: boolean = false;
  private _getInvoice(id) {
    if (id) {
      this._invoiceService
        .getInvoiceById(id)
        .pipe(take(1))
        .subscribe(
          (invoice: Invoice) => {
            this.invoice = invoice;
            // Initialize raw input with the loaded amount
            if (this.invoice.amountDue !== undefined && this.invoice.amountDue !== null) {
              this.amountDueRawInput = this.invoice.amountDue.toString();
            }
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
          }
        );
    }
  }

  saveAfterPublish() {
    if (this.isEditable && this.form.valid) {
      this.isUpdateAfterPublish = true;
      this.isSaveLoader = true;
      this._invoiceService
        .updateInvoiceAfterPublish(this.getInvoiceObject(true))
        .pipe(take(1))
        .subscribe(
          (response: boolean) => {
            this.invoice.required_Fields = response;
            if (!this.invoice.required_Fields) {
              this.invoice.required_Fields = this.validateForPublish();
            }
            $('.toast-success-inbox').hide();
            this._toasterMessageService.displayToasterState(
              ToasterTypes.SuccessInbox,
              '',
              `Updated`
            );
            this.isSaveLoader = false;
            this.fieldName = '';
            this.isEditable = false;
            this._getInvoice(this.invoice.id);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.ErrorInbox,
              '',
              `Error!`
            );
            this.fieldName = '';
          }
        );
    }
  }

  save(fieldName: string) {
    if (this.isEditable && !this.billsToPayMode) {
      this.isSaveLoader = true;
      this._invoiceService
        .updateInvoice(this.getInvoiceObject(true))
        .pipe(take(1))
        .subscribe(
          (response: boolean) => {
            this.invoice.required_Fields = response;
            if (!this.invoice.required_Fields) {
              this.invoice.required_Fields = this.validateForPublish();
            }
            $('.toast-success-inbox').hide();
            this._toasterMessageService.displayToasterState(
              ToasterTypes.SuccessInbox,
              '',
              `Updated`
            );
            this.isSaveLoader = false;
            this.fieldName = '';
            // The account is held on the form (this.account), not on the invoice, so add it:
            // without it a list behind the form never saw the category change.
            this.invoiceSaved.emit({
              ...this.invoice,
              ...(this.account ? { accountId: this.account.id, accountName: this.account.name } : {}),
            } as Invoice);
            if (fieldName == 'Local Currency' || fieldName == 'Total Amount') {
              if (this.invoice.id) {
                this._invoiceService
                  .getInvoiceById(this.invoice.id.toString())
                  .pipe(take(1))
                  .subscribe(
                    (invoice: Invoice) => {
                      this.invoice.unreconciledData = invoice.unreconciledData;
                    },
                    (e: Error) => {
                      this._toasterMessageService.displayToasterState(
                        ToasterTypes.Error,
                        'Error',
                        e.message
                      );
                    }
                  );
              }
            }
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.ErrorInbox,
              '',
              `Error!`
            );
            this.fieldName = '';
          }
        );
    }
  }

  validateForPublish(): boolean {
    if (this.isEditable) {
      if (this.form.invalid) {
        return false;
      }
    }
    return true;
  }
  isPublishing: boolean = false;
  submit() {
    if (this.isEditable) {
      let validFlag = true;
      this.updateSelectedAccountFormValue();

      if (this.form.invalid) {
        this.showPublishValidation = true;
        validFlag = false;

        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
          if (controls[name].invalid) {
            invalid.push(name);
          }
        }
        // Leave the line below
        return false;
      }

      this.showPublishValidation = false;

      if (validFlag) {
        if (this.isExpClaim) {
          if (this.invoice.paidBy == null) {
            this.paidByInvalid = true;
            return;
          }
          if (this.invoice.expenseReportId == null) {
            this.expenseReportIdInvalid = true;
            return;
          }
        }
        if (!this.currentSupplier?.name || this.isNewSupplier) {
          this.isPublishing = true;
          this.loading = true;
          this.addNewSupplier(this.newSupplier);
        } else if (this.isMatchPublish) {
          this.loading = true;
          this.matchUnreconciledData();
        } else {
          this.loading = true;
          this.publishInvoice();
        }
      }
    } else {
      this.matchUnreconciledData();
    }
  }

  publishInvoice() {
    // Remember which bill we are publishing before the optimistic advance swaps
    // `this.invoice` to the next one, so the success handler removes the right id.
    this._publishedInvoiceId = this.invoice.id?.toString() ?? null;
    if (this.type == 'ACCPAYCREDIT') {
      this.loading = true;
      this._invoiceService
        .publishCreditNote(this.getCreditNoteObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.handlePublishResult(data);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
            this.loading = false;
          }
        );
    } else if (this.type == 'EXP') {
      this.loading = true;
      this.publishReceipt();
    } else {
      this._invoiceService
        .publishInvoice(this.getInvoiceObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.handlePublishResult(data);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
            this.loading = false;
          }
        );
    }
    if (!this.isNextDisabled) {
      this.isPageLoaded = false;
      if (this.currentSelectedMatch == "")
        this.reroutAfterPublishing();
      else {
        this.loading = true;
      }
    }
  }

  publishReceipt() {
    if (this.IsQuickBook) {
      this._invoiceService
        .publishReceiptQBO(this.getReceiptObjectQBO())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.handlePublishResult(data);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
            this.loading = false;
          }
        );
    } else {
      this._invoiceService
        .publishReceipt(this.getReceiptObject())
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.handlePublishResult(data);
          },
          (e: Error) => {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              e.message
            );
            this.loading = false;
          }
        );
    }
  }

  private handlePublishResult(data: any) {
    // Publish succeeded — the bill has left "For Review", so tell the host to
    // drop it from the inbox table in the background (uses the id captured
    // before the optimistic advance, not the next bill now in `this.invoice`).
    if (this._publishedInvoiceId) {
      this.invoicePublished.emit(this._publishedInvoiceId);
      this._publishedInvoiceId = null;
    }
    if (!this.isReceipt && this.invoice.paymentStatus == 1) {
      this.invoice.referenceId = data.id;
      this.BatchPayment();
    }
    if (this.currentSelectedMatch == "") {
      if (this.isNextDisabled) {
        this.loading = false;
        this.reroutAfterPublishing();
      }
    }
    else {
      this.closeFormOnMatch.emit();
    }
  }

  reroutAfterPublishing(isDelete: boolean = false) {
    if (this.isNextDisabled) {
      if(this.overlayMode)
      {
        this._router.navigate(['/inbox'], { replaceUrl: true });
      }
      else{
        this.closeFormOnDeletePublish.emit(this.invoice.id.toString());
      }
    } else {
      this.clickNextArrow(isDelete);
    }
  }

  getPaymentStatusValue(item) {
    if (item != undefined || item != null) {
      return this.paymentStatusItem?.find((x) => x.value == item.value)?.value;
    } else {
      return this.paymentStatusItem[0].value;
    }
  }

  getInvoiceObject(isSaving: boolean = false): CreatedInvoiceWithLines {
    let invoice = new CreatedInvoiceWithLines();
    this.initInvoiceLine();
    invoice.amountDue = this.invoice.amountDue ?? 0;
    invoice.currency = this.invoice.currency;
    invoice.date = dateToString(new Date(this.invoice.date));
    invoice.dueDate = isSaving
      ? !this.invoice.dueDate
        ? dateToString(new Date(this.invoice.date))
        : dateToString(new Date(this.invoice.dueDate))
      : !this.invoice.dueDate
        ? this.invoice.date
        : dateToString(new Date(this.invoice.dueDate));
    // Planned Date (Xero planned payment date) is optional — null when unset.
    invoice.plannedDate = this.invoice.plannedDate
      ? dateToString(new Date(this.invoice.plannedDate))
      : null;
    invoice.supplierName = this.currentSupplier.name
      ? this.currentSupplier.name
      : this.invoice.supplierName;
    invoice.supplierId = this.currentSupplier.id;
    (invoice.id = this.invoice.id.toString() ?? ''),
      (invoice.invoiceNumber =
        this.invoice.invoiceNumber == '' ? null : this.invoice.invoiceNumber);
    invoice.organisationId =
      this.invoice.organisationId ??
      this._organizationService.selectedOrganization;
    invoice.paymentStatus = this.invoice.paymentStatus;
    invoice.pdfUrl = this.invoice.pdfUrl;
    invoice.subTotal = this.invoice.subTotal ?? 0;
    invoice.totalTax = this.invoice.totalTax ?? 0;
    invoice.type =
      this.type === 'ACCPAYCREDIT'
        ? DocumentType['Credit Note']
        : this.type === 'ACCPAY'
          ? DocumentType['Supplier Invoice']
          : this.type === 'ACCREC'
            ? DocumentType['Customer Invoice']
            : this.type === 'EXP'
              ? DocumentType['Receipt']
              : DocumentType['Expense Claim'];
    invoice.invoiceLines = this.invoice.invoiceLines;
    invoice.InvoiceOrCreditNote = this.type ?? this.invoice.type;
    invoice.paidBy = this.invoice.paidBy;
    invoice.expenseReportId = this.invoice.expenseReportId;
    invoice.expenseReportName = this.invoice.expenseReportName;
    invoice.paymentAccountNumber = this.invoice.paymentAccountNumber;
    invoice.paymentDate = this.invoice.paymentDate;
    invoice.unreconciledReportIds = this.unreconciledReportIds;
    invoice.requiredFields = this.form.valid;
    invoice.processed = this.invoice.processed;
    invoice.localCurrencyAmount = this.invoice.localCurrencyAmount;
    if (invoice.invoiceLines?.length > 0) {
      for (let line of invoice.invoiceLines) {
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }
    this.customFields.forEach((element) => {
      invoice.customField_Values.push({
        custom_field_id: element.custom_field_id,
        field_value: element.field_value,
        synced_invoice_id: invoice.id,
      });
    });

    return invoice;
  }

  getCreditNoteObject(isSaving: boolean = false): CreditNoteDTO {
    let creditNote = new CreditNoteDTO(
      this._organizationService.selectedOrganization
    );
    this.initCreditNoteLine();
    Object.keys(creditNote).reduce(
      (a, k) => ((a[k] = this.creditNote[k]), a),
      creditNote
    );
    creditNote.contact = {
      contactID: this.currentSupplier.id,
      name: this.currentSupplier.name,
      status: 'ACTIVE',
    };
    creditNote.invoiceID = this.invoice.id;
    creditNote.date = dateToString(this.invoice.date);
    creditNote.subTotal = this.invoice.subTotal;
    creditNote.totalTax = this.invoice.totalTax;
    creditNote.total = this.invoice.amountDue;
    creditNote.lineItems = this.lineItemList;
    // Per-line QBO customer ids, parallel to lineItems (SD-1177).
    creditNote.lineCustomerIds = (this.lineItemList || []).map(
      (li: any) => li.customerId || this.selectedCustomerId || this.invoice?.invoiceLines?.[0]?.customerId || null
    );
    // Per-line QBO class ids, parallel to lineItems (SD-1177).
    creditNote.lineClassIds = (this.lineItemList || []).map(
      (li: any) => li.classId || this.selectedQBOClassId || this.invoice?.invoiceLines?.[0]?.classId || null
    );
    creditNote.PdfUrl = this.invoice.pdfUrl;
    creditNote.creditNoteID = this.invoice.id.toString();
    creditNote.InvoiceOrCreditNote = 'Credit Note';
    creditNote.currency = this.defaultCurrency;
    creditNote.currencyCode = this.defaultCurrency;
    creditNote.invoiceNumber = this.invoice.invoiceNumber;
    creditNote.unreconciledReportIds = this.unreconciledReportIds;
    return creditNote;
  }

  getReceiptObject(isSaving: boolean = false): BankTransactionDTO {
    let bankTransaction = new BankTransactionDTO(
      this._organizationService.selectedOrganization
    );
    this.initReceiptLine();
    Object.keys(bankTransaction).reduce(
      (a, k) => ((a[k] = this.bankTransation[k]), a),
      bankTransaction
    );

    let currentPaymentFrom: any = this.bankAccountList.find(
      (x) => x.accountID == this.invoice.paymentAccountNumber
    );
    bankTransaction.bankAccount = {
      accountID: currentPaymentFrom?.accountID,
      name: currentPaymentFrom?.name,
      type:
        currentPaymentFrom?.type == 'CREDITCARD'
          ? 'BANK'
          : currentPaymentFrom?.type,
      currencyCode: this.invoice.currency,
      bankAccountNumber: currentPaymentFrom?.bankAccountNumber,
    };
    bankTransaction.contact = {
      contactID: this.currentSupplier.id,
      name: this.currentSupplier.name,
      status: 'ACTIVE',
    };
    bankTransaction.date = dateToString(this.invoice.date);
    bankTransaction.subTotal = this.invoice.subTotal;
    bankTransaction.totalTax = this.invoice.totalTax;
    bankTransaction.total = this.invoice.amountDue;
    bankTransaction.PdfUrl = this.invoice.pdfUrl;
    bankTransaction.invoiceId = this.invoice.id.toString();
    bankTransaction.InvoiceOrCreditNote = 'Receipt';
    bankTransaction.type = DocumentType['Receipt'];
    bankTransaction.currency = this.defaultCurrency;
    bankTransaction.currencyCode = this.defaultCurrency;
    bankTransaction.invoiceNumber = this.invoice.invoiceNumber;
    bankTransaction.paymentAccountNumber = this.invoice.paymentAccountNumber;
    bankTransaction.paymentStatus = this.invoice.paymentStatus;
    bankTransaction.lineItems = this.invoice.invoiceLines;
    bankTransaction.unreconciledReportIds = this.unreconciledReportIds;
    if (bankTransaction.lineItems?.length > 0) {
      for (let line of bankTransaction.lineItems) {
        line.accountName = '';
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }
    return bankTransaction;
  }

  getReceiptObjectQBO(isSaving: boolean = false): CreatedInvoiceWithLines {
    let invoice = new CreatedInvoiceWithLines();
    this.initInvoiceLine();
    invoice.amountDue = this.invoice.amountDue ?? 0;
    invoice.currency = this.invoice.currency;
    invoice.date = dateToString(this.invoice.date);
    invoice.dueDate = isSaving
      ? dateToString(this.invoice.dueDate)
      : !this.invoice.dueDate
        ? this.invoice.date
        : dateToString(this.invoice.dueDate);
    invoice.supplierName = this.currentSupplier.name
      ? this.currentSupplier.name
      : this.invoice.supplierName;
    invoice.supplierId = this.currentSupplier.id;
    (invoice.id = this.invoice.id.toString() ?? ''),
      (invoice.invoiceNumber = this.invoice.invoiceNumber);
    invoice.organisationId =
      this.invoice.organisationId ??
      this._organizationService.selectedOrganization;
    invoice.paymentStatus = this.invoice.paymentStatus;
    invoice.pdfUrl = this.invoice.pdfUrl;
    invoice.subTotal = this.invoice.subTotal ?? 0;
    invoice.totalTax = this.invoice.totalTax ?? 0;
    invoice.type =
      this.type === 'ACCPAYCREDIT'
        ? DocumentType['Credit Note']
        : this.type === 'ACCPAY'
          ? DocumentType['Supplier Invoice']
          : this.type === 'ACCREC'
            ? DocumentType['Customer Invoice']
            : this.type === 'EXP'
              ? DocumentType['Receipt']
              : DocumentType['Expense Claim'];
    invoice.invoiceLines = this.invoice.invoiceLines;
    invoice.InvoiceOrCreditNote = this.type ?? this.invoice.type;
    invoice.paidBy = this.invoice.paidBy;
    invoice.expenseReportId = this.invoice.expenseReportId;
    invoice.expenseReportName = this.invoice.expenseReportName;
    invoice.paymentAccountNumber = this.invoice.paymentAccountNumber;
    invoice.paymentDate = this.invoice.paymentDate;
    invoice.unreconciledReportIds = this.unreconciledReportIds;
    if (invoice.invoiceLines?.length > 0) {
      for (let line of invoice.invoiceLines) {
        line.organisationId =
          this.invoice.organisationId ??
          this._organizationService.selectedOrganization;
        if (line.totalTax == null) {
          line.totalTax = 0;
        }
      }
    }

    return invoice;
  }

  updateInvoiceLines(updatedLines: UpdatedLines) {
    this.updateTotals(updatedLines.invoiceTotals);
    this.invoice.invoiceLines = updatedLines.invoiceLines;

    if (updatedLines?.invoiceLines?.length > 0) {
      this.account = this.accounts.find(
        (acc) => acc.id == this.invoice.invoiceLines[0]?.accountId
      );
      this.updateSelectedAccountFormValue();
    }

    this.selectedTaxRateId = this.invoice.invoiceLines[0]?.taxId;
    this.updateSelectedTaxRateFormValue(this.selectedTaxRateId);

    if (this.invoice.invoiceLines?.length === 1) this.setValuesForOneLine();
    this.saveInvoiceWithDelay('Invoice lines');
  }

  updateSelectedAccountFormValue() {
    // null (not '') when empty so ng-select shows its placeholder; an empty
    // string counts as a value and suppresses it.
    this.form.patchValue({
      account: this.account?.name ? this.accountLabel(this.account) : null,
    });
    this.form.markAsUntouched();
  }

  updateSelectedTaxRateFormValue(selectedTaxRateId: string) {
    this.form.patchValue({
      selectedTaxRate: selectedTaxRateId,
    });
    this.form.markAsUntouched();
  }

  getTaxRates() {
    this._organizationService
      .getTaxRates(this._organizationService.selectedOrganization)
      .pipe(this.untilThis)
      .subscribe(
        (taxRates: TaxRate[]) => {
          // if (this.IsQuickBook || this.IsNoAccounting) {
          //   taxRates.push(this.qboTaxDefault);
          // }
          this.taxRates = taxRates;
          this.handleTotals();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  getOrganizationDefaultCurrency() {
    this._organizationService
      .getOrganizationDefaultCurrency(
        this._organizationService.selectedOrganization
      )
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.defaultCurrency = response.currency;
          this.handleInvoiceCurrency();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  getSelectedTaxRate() {
    this._organizationService
      .getOrganizationTaxRateId(this._organizationService.selectedOrganization)
      .pipe(this.untilThis)
      .subscribe(
        (response) => {
          if (response.taxBasis == TaxBasis.IgnoreTax) {
            if (this.IsXero && this.isInboxMode) {
              this.DefaultTaxModel.show();
            }
            else {
              this.taxRates = [];
              this.orgTaxBasis = response.taxBasis;
              this.taxRates.push(this.qboTaxDefault);
              this.selectedTaxRateId = '0';
              this.organizationTaxRateId = '0';
            }
          } else {
            if (!this.invoice?.invoiceLines[0]?.taxId) {
              this.selectedTaxRateId = response.taxRateId;
            }
            this.selectedExclusivTaxRateId = response.taxExclusiveRateId;
            this.organizationTaxRateId = response.taxRateId;
          }
          this.handleTotals();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  addAlias() {
    this._suppliersService
      .saveSupplierAlias({
        id: Guid.create().toString(),
        organizationId: this._organizationService.selectedOrganization,
        supplierId: this.currentSupplier.id,
        alias: this.currentSupplier.alias,
      })
      .pipe(take(1))
      .subscribe(
        () => {
          this.isNewSupplier = false;
          this.toggleAliasWarning();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  toggleCreateSupplierForm(state: boolean) {
    this.resetDateLoadingVars();

    if (this.isEditable) {
      this.newSupplier.supplierId = this.currentSupplier.id;
      this.newSupplier.name = this.currentSupplier.name
        ? this.currentSupplier.name
        : this.currentSupplier.alias;
    } else {
      this.newSupplier.supplierId = this.invoice.supplierId;
      this.newSupplier.name = this.invoice.supplierName;
    }

    if (state) {
      this.currentPannel = Pannels.ContactForm;
    } else {
      this.currentPannel = Pannels.RelatedTab;
    }
  }

  toggleAliasWarning() {
    this.isAliasWarningShown = !this.isAliasWarningShown;
    this.showSupplierTooltip = false;
  }

  toggleDuplicateWarning() {
    this.isDuplicateWarningShown = !this.isDuplicateWarningShown;
    this.showRefTooltip = false;
  }

  toggleAccountWarning() {
    this.isAccountWarningShown = !this.isAccountWarningShown;
    this.showAccountTooltip = false;
  }

  toggleTaxAmountWarning() {
    this.isDifferentTaxAmount = !this.isDifferentTaxAmount;
  }

  addLinesShow() {
    this.resetDateLoadingVars();
    this.initInvoiceLine();
    if (this.currentPannel == Pannels.SplitLinesPanel) {
      this.currentPannel = Pannels.DetailsTab;
    } else {
      this.currentPannel = Pannels.SplitLinesPanel;
    }
    this.calculateDivHeight();
  }

  showKeyValuePairs() {
    this.resetDateLoadingVars();
    this.isJsonKeyValueShown = !this.isJsonKeyValueShown;
  }

  showActivityPanel(isDefaultShow: boolean) {
    this.resetDateLoadingVars();
    if (!isDefaultShow) {
      if (this.currentPannel == Pannels.ActivityTab) {
        this.currentPannel = Pannels.DetailsTab;
      } else {
        this.currentPannel = Pannels.ActivityTab;
      }
    }
  }

  showRelatedPanel() {
    this.resetDateLoadingVars();
    if (this.currentPannel == Pannels.RelatedTab) {
      this.currentPannel = Pannels.DetailsTab;
    } else {
      this.currentPannel = Pannels.RelatedTab;
    }
  }

  clickNextArrow(isDelete: boolean = false) {
    var nextid = this._inboxInvoicesStorage.getNextInvoiceId(
      this.invoice.id?.toString()
    );
    if (isDelete && this.isEditable) {
      this._inboxInvoicesStorage.deleteInvoiceIdFromStorage(
        this.invoice.id?.toString()
      );
    }
    // Inbox overlay: swap the bill in place (host updates the `id` query param)
    // rather than navigating away to the full-page route.
    if (this.overlayMode) {
      // The reused form keeps showing the old bill until the next one's data
      // arrives, so show the panel loading spinner during the swap. It is
      // cleared again when the new invoice loads (existingInvoiceState$).
      if (nextid) {
        this.isSpinnerShown = true;
      }
      this.navigateInvoice.emit({ id: nextid, editMode: this.isEditable });
      return;
    }
    const route = this.isEditable ? 'editInvoice' : 'viewInvoice';
    // this._router.navigateByUrl('/').then(() => {
    this._router.navigate([`/inbox/${route}/${nextid}`], {
      replaceUrl: true,
    });
    // });
  }

  clickPreviousArrow() {
    const previousId = this._inboxInvoicesStorage.getPreviousInvoiceId(
      this.invoice.id?.toString()
    );
    if (this.overlayMode) {
      if (previousId) {
        this.isSpinnerShown = true;
      }
      this.navigateInvoice.emit({ id: previousId, editMode: this.isEditable });
      return;
    }
    const route = this.isEditable ? 'editInvoice' : 'viewInvoice';
    this._router.navigateByUrl('/').then(() => {
      this._router.navigate([`/inbox/${route}/${previousId}`], {
        replaceUrl: true,
      });
    });
  }

  saveOnLostFocus(fieldName: string) {
    // Special handling for Total Amount field: resolve math expression on blur
    if (fieldName === 'Total Amount') {
      // If empty and invoice.amountDue exists, use that
      if ((!this.amountDueRawInput || this.amountDueRawInput === '') && this.invoice?.amountDue) {
        this.amountDueRawInput = this.invoice.amountDue.toString();
      }

      let input = this.amountDueRawInput;
      let evaluated = null;
      if (typeof input === 'string') {
        const sanitized = input.replace(/[^0-9.+\-*/()]/g, '');
        if (/^[0-9().+\-*/]+$/.test(sanitized)) {
          try {
            evaluated = this.evaluateExpression(sanitized);
            if (/^[0-9()./]+$/.test(evaluated)) {
              evaluated = parseFloat(evaluated)
            }
          } catch {
            evaluated = null;
          }
        }
      } else if (typeof input === 'number') {
        evaluated = input;
      }
      if (typeof evaluated === 'number' && !isNaN(evaluated)) {
        if (evaluated < 0) evaluated = Math.abs(evaluated);
        // Format to 2 decimals and set as both raw input and model
        this.amountDueRawInput = evaluated.toFixed(2);
        this.invoice.amountDue = evaluated;
      }
      // If not valid, leave raw input as is (do not overwrite)
    }
    if (this.fieldWasChanged && !this.invoice.processed) {
      this.fieldWasChanged = !this.fieldWasChanged;
      this.save(fieldName);
    }
  }


  onDateChange() {
    // A new date should re-surface the old-date reminder if it still applies.
    if (this.dateChanged) this.oldDateNoticeDismissed = false;
    // Handle if the date is a string (manually entered)
    if (this.invoice.date) {
      let dateInput = "";
      if (typeof this.invoice.date === 'object') {
        if (this.dateFormat === 'en-GB') {
          dateInput = String(
            new Date(this.invoice.date).getDate() +
            "/" +
            (new Date(this.invoice.date).getMonth()) +
            "/" +
            new Date(this.invoice.date).getFullYear()
          ).trim();
        }
        else {
          dateInput = String(
            (new Date(this.invoice.date).getMonth()) +
            "/" +
            new Date(this.invoice.date).getDate() +
            "/" +
            new Date(this.invoice.date).getFullYear()
          ).trim();
        }
      } else if (typeof this.invoice.date === "string") {
        dateInput = String(this.invoice.date).trim();
      }

      if (dateInput) {
        const parsed = parseDateByFormat(dateInput, this.dateFormat);
        if (parsed) {
          // Store as Date object
          this.invoice.date = parsed;
        } else {
          // Show error for invalid input
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Warning,
            'Invalid Date Format',
            `Please use ${this.dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'} format.`
          );
        }
      }
    }
    if (!this.invoice.date) {
      this.dateLoading = true;
      this._toasterMessageService.displayToasterState(
        ToasterTypes.Warning,
        'Invalid Date Format',
        `Please use ${this.dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'} format.`
      );
      this.invoice.date = new Date();
    } else {
      // Check if date is in the future
      if (this.invoice.date && this.invoice.date > new Date() && this.showLocalCurrency) {
        this.invoice.date = new Date();
      }
      this.fieldName = 'Date';
      if (this.dateChanged) this.saveDateWhenFocusout();
    }
    this.showRecalculate = true;
    if (this.dateChanged) this.getExchangeRateAndCalculateLocalAmount();
  }

  onDueDateChange() {
    // Handle if the due date is a string (manually entered)
    if (this.invoice.dueDate) {
      let dateInput = "";
      if (typeof this.invoice.dueDate === 'object') {
        if (this.dateFormat === 'en-GB') {
          dateInput = String(
            new Date(this.invoice.dueDate).getDate() +
            "/" +
            (new Date(this.invoice.dueDate).getMonth()) +
            "/" +
            new Date(this.invoice.dueDate).getFullYear()
          ).trim();
        }
        else {
          dateInput = String(
            (new Date(this.invoice.dueDate).getMonth()) +
            "/" +
            new Date(this.invoice.dueDate).getDate() +
            "/" +
            new Date(this.invoice.dueDate).getFullYear()
          ).trim();
        }
      } else if (typeof this.invoice.dueDate === "string") {
        dateInput = String(this.invoice.dueDate).trim();
      }

      if (dateInput) {
        const parsed = parseDateByFormat(dateInput, this.dateFormat);
        if (parsed) {
          // Store as Date object
          this.invoice.dueDate = parsed;
        } else {
          // Show error for invalid input
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Warning,
            'Invalid Date Format',
            `Please use ${this.dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'} format.`
          );
        }
      }
    }

    if (!this.invoice.dueDate) {
      this.dueDateLoading = true;
      this._toasterMessageService.displayToasterState(
        ToasterTypes.Warning,
        'Invalid Date Format',
        `Please use ${this.dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'} format.`
      );
    } else {
      this.fieldName = 'Due Date';
      if (!this.isExpClaim && this.dueDateChanged) {
        this.saveDateWhenFocusout();
      }
    }
  }

  // Planned Date is optional (Xero planned payment date). Parse manual input like
  // Due Date, but an empty value is allowed (clears the field) — then autosave.
  onPlannedDateChange() {
    if (this.invoice.plannedDate) {
      let dateInput = "";
      if (typeof this.invoice.plannedDate === 'object') {
        if (this.dateFormat === 'en-GB') {
          dateInput = String(
            new Date(this.invoice.plannedDate).getDate() +
            "/" +
            (new Date(this.invoice.plannedDate).getMonth()) +
            "/" +
            new Date(this.invoice.plannedDate).getFullYear()
          ).trim();
        } else {
          dateInput = String(
            (new Date(this.invoice.plannedDate).getMonth()) +
            "/" +
            new Date(this.invoice.plannedDate).getDate() +
            "/" +
            new Date(this.invoice.plannedDate).getFullYear()
          ).trim();
        }
      } else if (typeof this.invoice.plannedDate === "string") {
        dateInput = String(this.invoice.plannedDate).trim();
      }

      if (dateInput) {
        const parsed = parseDateByFormat(dateInput, this.dateFormat);
        if (parsed) {
          this.invoice.plannedDate = parsed;
        } else {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Warning,
            'Invalid Date Format',
            `Please use ${this.dateFormat === 'en-GB' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'} format.`
          );
          return;
        }
      }
    }

    this.fieldName = 'Planned Date';
    if (this.plannedDateChanged) {
      this.saveDateWhenFocusout();
    }
  }

  saveDateWhenFocusout() {
    if (!this.invoice.processed) {
      setTimeout(() => {
        const btn = document.getElementById('saveButton');
        btn.focus();
        btn.click();
      }, 1000);
    }
  }

  updateBankDetails(countryCode) {
    if (countryCode == 'US') {
      this.bankAccount.routingNumber = this.invoice.routingNumber;
      this.bankAccount.accountNumberUS = this.invoice.accountNumberUS;
    } else {
      this.bankAccount.BSBNumber = this.invoice.bsbNumber;
      this.bankAccount.accountNumber = this.invoice.accountNumber;
    }
    this.bankAccount.branchDetails = this.bankAccount.BSBNumber;
    this.updateBankAccount(this.bankAccount, countryCode);
  }

  saveBankDetails(countryCode) {
    if (!this.isNewSupplier) {
      this.updateBankDetails(countryCode);
    } else {
      this._toasterMessageService.displayToasterState(
        ToasterTypes.Warning,
        "Bank Account isn't saved",
        'Please, create a new supplier first'
      );
    }
  }

  addPaymentAccount() {
    this.showPaymentAccountFields = true;
  }

  addUSPaymentAccount() {
    this.showUSPaymentAccountFields = true;
  }

  bankAccountChanged(value: string, countryCode: string) {
    if (this.isNewSupplier) {
      this._toasterMessageService.displayToasterState(
        ToasterTypes.Warning,
        "Bank Account isn't saved",
        'Please, create a new supplier first'
      );
      return;
    }

    if (
      this.bankAccount?.BSBNumber &&
      this.bankAccount?.accountNumber &&
      this.bsbPattern.test(this.bankAccount?.BSBNumber) &&
      this.accountNumberPattern.test(this.bankAccount?.accountNumber)
    ) {
      this.updateBankAccount(this.bankAccount, countryCode);
    }
  }

  updateBSB(bsb: string) {
    this.bankAccount.BSBNumber = bsb.length === 3 ? bsb + '-' : bsb;

    if (bsb.length === 7) {
      this.getBankName(bsb);
    }
  }

  bankAccountUSChanged(value: string) {
    if (this.isNewSupplier) {
      this._toasterMessageService.displayToasterState(
        ToasterTypes.Warning,
        "Bank Account isn't saved",
        'Please, create a new supplier first'
      );
      return;
    }
    if (
      this.bankAccount?.routingNumber &&
      this.bankAccount?.accountNumberUS &&
      this.routingPattern.test(this.bankAccount?.routingNumber) &&
      this.accountNumberPattern.test(this.bankAccount?.accountNumberUS)
    ) {
      this.updateUSBankAccount(this.bankAccount);
    }
  }

  updateUSBankAccount(account: BankAccount) {
    const updatedAccount = JSON.parse(JSON.stringify(account));
    updatedAccount.routingNumber = account.routingNumber;
    updatedAccount.accountNumberUS = account.accountNumberUS;
    updatedAccount.contactId = this.invoice.supplierId;
    updatedAccount.accountName = this.invoice.supplierName;

    this._organizationService
      .UpdateBankAccount(updatedAccount)
      .pipe(take(1))
      .subscribe(
        () => {
          this.warningIsReadyToBeShown = false;
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Success,
            'Success',
            'Bank Account Updated!'
          );
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  updateRouting(routingNumber: string) {
    this.bankAccount.routingNumber = routingNumber;
  }

  tabClick(tab: Pannels, isDefaultShow: boolean) {
    switch (tab) {
      case Pannels.DetailsTab:
        this.currentPannel = Pannels.DetailsTab;
        break;
      case Pannels.ActivityTab:
        this.showActivityPanel(isDefaultShow);
        break;
      case Pannels.RelatedTab:
        this.showRelatedPanel();
        break;
      default:
        this.currentPannel = Pannels.DetailsTab;
        break;
    }
  }

  /**
   * Expand a side-panel record into the inbox's own record view (the `?id=` overlay), on the
   * tab its status lives under. The full-page editInvoice route this used to open in a new tab
   * had no way back to the inbox and always opened published bills as editable.
   */
  openInInbox() {
    const id = this.invoice.id;
    const isProcessed = !!this.invoice.processed;
    this.closeFormOnBillsToPay();
    // The inbox turns off route reuse, so this rebuilds it (and reads the `id` deep link) even
    // when it's already the page behind the panel.
    this._router.navigate(['/inbox'], { queryParams: { isProcessed, id } });
  }

  viewInvoice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || environment.isOutlookEnv || environment.isChromeEnv) {
      // true for mobile device
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
    if (this.isMobileDevice) {
      this.currentPannel = Pannels.InvoiceDetails;
      this.isPreviewVisible = true;
    } else {
      // link.setAttribute('target', '_blank');
      // link.setAttribute('href', this._invoiceService.getDownloadInvoiceUrl(this.invoice.referenceId ?? this.invoice.pdfUrl, this._organizationService.selectedOrganization));
      // link.setAttribute('download', this.invoice.referenceId ?? this.invoice.pdfUrl);
      // link.click();
      // link.remove();
      // this.currentPannel = Pannels.InvoiceDetails;
      this.isPreviewVisibleWeb = true;
    }
  }

  closeFormOnBillsToPay() {
    this._inboxInvoicesStorage.removeInvoiceArray();
    this.closeFormOnBillsToPayEvent.emit();
  }

  /** The ids this bill is known by, for its approval block: its own, and its ledger id once published. */
  get reviewRecordIds(): string[] {
    const key = `${this.invoice?.id || ''}|${this.invoice?.referenceId || ''}`;
    if (key !== this._reviewKey) {
      this._reviewKey = key;
      this._reviewIds = [this.invoice?.id?.toString(), this.invoice?.referenceId].filter(id => !!id);
    }
    return this._reviewIds;
  }

  approveCurrentInvoice() {
    this.isApproving = true;

    const reportDataModel = {
      ApproveId: '',
      OrganizationId: this._organizationService.selectedOrganization,
      InvoiceId: this.invoice.referenceId ?? this.invoice.id.toString(),
      ApproveBy: localStorage.getItem('UpUserId'),
      ApprovedByName: localStorage.getItem('UserName'),
      ApprovalDate: new Date(),
    };

    this._organizationService
      .InsertApprovals(reportDataModel)
      .pipe(this.untilThis)
      .subscribe(
        (data) => {
          if (data.status == 1) {
            this.isApproving = false;
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Success,
              'Success',
              'You have approved the bill'
            );
            this.invoiceApprovedEvent.emit(reportDataModel.InvoiceId);
          }
        },
        (e: Error) => {
          this.isApproving = false;
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  private resetDateLoadingVars() {
    this.dateLoading = false;
    this.dueDateLoading = false;
  }

  private _getCategoryName(id: string) {
    return this.trackingCategories.find((c) => c.id === id).name;
  }

  private checkTaxAmount() {
    this.isDifferentTaxAmount =
      this.invoice.totalTax !== this.currentTotalTax &&
        !this.taxRates.includes(this.qboTaxDefault)
        ? true
        : false;
  }

  private getTaxRateById(id: string): number | null {
    return this.taxRates.find((tr) => tr.id === id)?.rate;
  }

  private handleInvoiceType() {
    this.loadPaymentStatus(this.invoice?.type);
    if (this.invoice.type !== null) {
      let invoiceType = this.invoice.type.toString();
      if (invoiceType == 'Credit Note' || invoiceType == 'ACCPAYCREDIT') {
        this.type = 'ACCPAYCREDIT';
        this.invoiceSelectedType = 'Credit Note';
        this.isExpClaim = false;
      } else if (invoiceType == 'Supplier Invoice' || invoiceType == 'ACCPAY') {
        this.type = 'ACCPAY';
        this.invoiceSelectedType = 'Supplier Invoice';
        this.isExpClaim = false;
      } else if (invoiceType == 'Customer Invoice' || invoiceType == 'ACCREC') {
        this.type = 'ACCREC';
        this.invoiceSelectedType = 'Customer Invoice';
        this.isExpClaim = false;
      } else if (invoiceType == 'Expense Claim' || invoiceType == 'EXPCLAIMS') {
        this.type = 'EXPCLAIMS';
        this.invoiceSelectedType = 'Expense Claim';
        this.isExpClaim = true;
      } else if (invoiceType == 'Receipt' || invoiceType == 'EXP') {
        this.type = 'EXP';
        this.invoiceSelectedType = 'Receipt';
        this.isExpClaim = false;
        this.isReceipt = true;
      }
    } else {
      this.type = 'ACCPAY';
      this.invoiceSelectedType = 'Supplier Invoice';
    }
    this.setFormValidator(this.type);
  }

  private handleInvoiceLines() {
    if (this.invoice.invoiceLines?.length > 0) {
      for (let line of this.invoice.invoiceLines) {
        line = new InvoiceLine(
          line.organisationId,
          line.id,
          line.taxId,
          line.trackingOptions,
          line.amountDue,
          line.totalTax,
          line.subTotal,
          line.description,
          line.accountId,
          line.quantity
        );
      }
    }
  }

  private getOrganizationCurrencies() {
    this._organizationService
      .getOrganizationCurrencies(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (data: string[]) => {
          this.currencies = data;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  private getOrganizationCustomFields() {
    this._organizationService
      .getOrganizationCustomFields(
        this._organizationService.selectedOrganization,
        this.invoice.id.toString(),
        true,
        false,
        false
      )
      .pipe(take(1))
      .subscribe(
        (data: customFields[]) => {
          this.customFields = data;
          this.customFields.forEach((x, index) => {
            if (x.field_type == 'dropdown') {
              x.optionsArr = [];
              var tempArr = x.options.replace('{[', '').replace(']}', '');
              var tempArr1 = tempArr
                .replace(/"},{"/g, ';')
                .replace('{', '')
                .replace('}', '')
                .replace(/"/g, '')
                .replace(/'/g, '')
                .split(',');
              tempArr1.forEach((i) => {
                if (i != '') x.optionsArr.push(i);
              });
            }
          });
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  private handleInvoiceCurrency() {
    if (
      this.suppliers?.length > 0 &&
      this.defaultCurrency &&
      this.invoice?.id
    ) {
      if (!this.invoice.currency || (this.invoice.currency && this.invoice.currency.toString() == '0')) {
        const supplier = this.suppliers.find(
          (s) => s.id == this.invoice.supplierId
        );
        if (
          supplier &&
          supplier.defaultCurrency != null &&
          supplier.defaultCurrency != '0'
        ) {
          this.invoice.currency = Object.values(CurrencyCode).find(
            (v) => v.toString() == supplier.defaultCurrency
          );
        } else {
          this.invoice.currency = this.defaultCurrency;
        }
        this.bankAccount.currency = this.invoice.currency;
      }

      // Compare currencies and update showLocalCurrency flag
      this.showLocalCurrency = this.invoice.currency !== this.defaultCurrency;

      // Initialize local currency amount if not set
      if (
        this.showLocalCurrency &&
        !this.invoice.localCurrencyAmount &&
        this.invoice.amountDue &&
        this.currencyChanged
      ) {
        this.getExchangeRateAndCalculateLocalAmount();
      }
    } else {
      this.invoice.currency = Object.values(CurrencyCode).find(
        (v) => v.toString() == this.invoice.currency
      );
      if (!this.invoice.currency) {
        this.invoice.currency = this.defaultCurrency;
        this.bankAccount.currency = this.invoice.currency;
      }
      // Compare currencies and update showLocalCurrency flag
      this.showLocalCurrency = this.invoice.currency !== this.defaultCurrency;
    }
  }

  GetBankAcoountDetails() {
    this._organizationService
      .GetBankAccountDetails(
        'Organisation/GetBankAccountDetails',
        this._organizationService.selectedOrganization
      )
      .subscribe(
        (response: any) => {
          if (response.status == 0) {
            this.bankAccountList = response.data;
            if (this.bankAccountList?.length > 0) {
              this.bankAccountList.forEach((payAcc) => {
                payAcc.accountID = payAcc.accountID.toLowerCase();
              });
              this.selectedBankAccount = this.bankAccountList[0].accountID;
              this.updatePaymentAccount();
              if (this.bankAccountList[0]['bankName'] === 'NAB') {
                //this.isNABBank = true;
              }
            }
          }
        },
        (err) => {
          this.bankAccountList = [];
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            err.message
          );
        }
      );
  }
  onSelectPaymentAccount(e) {
    this.MyBankAccount = this.bankAccountList.find(
      (x) => x.accountID === e.accountID
    );
    this.invoice.paymentAccountNumber = e.accountID;
    this.saveInvoiceWithDelay('PaymentAccountNumber');
  }

  savePaymentDateWhenFocusout($event) {
    if (!this.paymentDateLoading) {
      this.paymentDateLoading = true;
    } else {
      this.saveInvoiceWithDelay('PaymentDate');
      let datePipe = new DatePipe(this.dateFormat);
      this.reportName =
        'Payments ' +
        datePipe.transform(
          this.invoice.paymentDate,
          this.dateFormat == 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'
        );
    }
  }

  saveLocalCurrencyWhenFocusout($event) {
    if (this.fieldWasChanged && !this.invoice.processed) {
      this.saveOnLostFocus('Local Currency');
      this.localCurrencyWasChanged = false;
    }
  }

  // Payment Stuff Starts
  BatchPayment() {
    this.subscriptions.push(
      this._userService.loggedUserDetails.subscribe((data) => {
        if (data) {
          this.userDetails = data;
        } else {
          this.userDetails = [];
        }
      })
    );
    this.subscriptions.push(
      this._userService.userRole$.subscribe((data) => {
        this.userRole = data;
      })
    );
    let payment = [];
    let accountnumber = this.selectedBankAccount;

    if (this.IsQuickBook) {
      let paymentitem = {
        id: null,
        invoiceID: this.invoice.id,
        dueAmount: this.invoice.amountDue,
        contactID: this.currentSupplier.id,
        invoiceNumber: this.invoice.invoiceNumber,
        details: this.invoice.organisationId,
        contactName: this.currentSupplier.name,
        referenceId: this.invoice.referenceId,
      };
      payment.push(paymentitem);
    } else if (this.IsNoAccounting) {
      let paymentitem = {
        id: null,
        invoiceID: this.invoice.referenceId,
        dueAmount: this.invoice.amountDue,
        contactID: this.currentSupplier.id,
        invoiceNumber: this.invoice.invoiceNumber,
        details: this.invoice.organisationId,
        contactName: this.currentSupplier.name,
        referenceId: this.invoice.referenceId,
      };
      payment.push(paymentitem);
    } else {
      let paymentitem = {
        id: null,
        invoiceID: this.invoice.referenceId,
        dueAmount: this.invoice.amountDue,
        contactID: this.currentSupplier.id,
        invoiceNumber: this.invoice.invoiceNumber,
        details: this.invoice.organisationId,
        contactName: this.currentSupplier.name,
        referenceId: this.invoice.referenceId,
      };
      payment.push(paymentitem);
    }

    let userId = Number(this.userDetails.userId);
    let batchPayment = {
      PaymentId: null,
      ReportName: this.reportName,
      AccountID: this.invoice.paymentAccountNumber,
      AccountName: this.MyBankAccount != null ? this.MyBankAccount.name : '',
      Paymentitem: payment,
      CreatedBy: userId,
      OrganisationId: this._organizationService.selectedOrganization,
      PaymentDate: this.invoice.paymentDate,
      PaymentAccountNumber: this.invoice.paymentAccountNumber,
    };

    this._organizationService
      .OutstandingBatchPaymentFromInbox(
        this._organizationService.selectedOrganization,
        batchPayment
      )
      .pipe(take(1))
      .subscribe(
        (data) => {
          if (data.status == 1) {
            this._toasterMessageService.displayToasterState(
              ToasterTypes.SuccessWithHtml,
              null,
              'Bill ' +
              this.invoice.invoiceNumber +
              '  has been processed and mark as paid'
            );
            this.loading = false;
            this.closeContactForm(this.invoice.id.toString());
            //this.reroutAfterPublishing();
          } else {
            if (data.message == 'ConnectionLost') {
              if (this.IsQuickBook) {
                this._organizationService.getIntegrationCredentials('qbo').subscribe((res) => {
                  if (res) {
                    this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                    this._toasterMessageService.displayToasterState(
                      ToasterTypes.ErrorWithHtml,
                      null,
                      `QuickBooks connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                    );
                  }
                });
              } else {
                this._organizationService.getIntegrationCredentials('xero').subscribe((res) => {
                  if (res) {
                    this._organizationService.refreshConnectionURL = res.revokeEndPoint;
                    this._toasterMessageService.displayToasterState(
                      ToasterTypes.ErrorWithHtml,
                      null,
                      `Xero connection lost. Please <a  class=\"toastr-link\" href=\"${this._organizationService.refreshConnectionURL}\">refresh</a> connection`
                    );
                  }
                });
              }
            } else {
              this._toasterMessageService.displayToasterState(
                ToasterTypes.Error,
                'Error',
                data.message
              );
            }
          }
        },
        (err) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            err.message
          );
        }
      );
  }

  // Expense Claim Stuff goes here

  private getOrganizationUsers() {
    this._userService
      .getUsersByOrganizationId(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          if (response != null) {
            this.users = response.data;
            if (this.users.length > 0) {
              if (
                this.invoice.paidBy != null &&
                this.users.find((p) => p.id == this.invoice.paidBy) != null
              ) {
                this.invoice.paidByName = this.users.find(
                  (p) => p.id == this.invoice.paidBy
                ).name;
                this.getOrganizationExpClaims();
              } else {
                this.invoice.paidBy = null;
              }
            } else {
              this.invoice.paidBy = null;
            }
          }
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  onSelectPaidBy(event) {
    if (event != undefined) {
      this.invoice.paidBy = event.id.toString().toLowerCase();
      this.save('Paid By');
      this.getOrganizationExpClaims();
      this.paidByInvalid = false;
    } else {
      this.invoice.paidBy = null;
      this.invoice.expenseReportId = null;
      this.invoice.expenseReportName = null;
      this.invoice.paidByName = null;
      this.save('Paid By');
    }
  }

  private getOrganizationExpClaims() {
    this._invoiceService
      .getAllExpClaimsByOrganizationId(
        this._organizationService.selectedOrganization,
        this.invoice.paidBy
      )
      .subscribe(
        (response: any) => {
          if (response != null) {
            this.expClaims = response.data;
            if (this.expClaims.length > 0) {
              this.updateExpReportStatus();
            } else {
              this.invoice.expenseReportId = null;
            }
          }
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            e.message
          );
        }
      );
  }

  onSelectExpenseReport(event) {
    this.isLoaded = true;
    this.isNewExpReportLoaded = true;
    if (event == undefined) {
      this.isNewExpReport = true;
      this.save('Expense Report');
      this.expenseReportIdInvalid = false;
      return;
    }
    this.isNewExpReport = false;
    this.isCreateExpReportItemShown = this.isNewExpReport;
    this.invoice.expenseReportId = event.id.toString().toLowerCase();
    this.save('Expense Report');
    this.expenseReportIdInvalid = false;
  }

  handleExpenseReport(event) {
    if (event != undefined && event != '') {
      this.newExpReport.reportName = event;
      const matchedExpReport = this.expClaims.filter(
        (s) => s.reportName == this.newExpReport.reportName
      );

      if (matchedExpReport?.length == 0 && event) {
        this.isCreateExpReportItemShown = true;
      } else if (!event) {
        this.handleExpenseReportBlur();
      } else {
        this.isCreateExpReportItemShown = false;
      }
    } else {
    }
  }

  handleExpenseReportBlur() {
    this.newExpReport.id = this.invoice.expenseReportId;
    this.isCreateExpReportItemShown = this.isNewExpReport;
  }

  createNewExpReport() {
    if (!this.creatingNewExpReport) {
      this.creatingNewExpReport = true;
      this.addNewExpReport(this.newExpReport, false);
    }
  }

  addNewExpReport(
    expReport: SyncedExpClaims,
    setInvoiceExpReportName: boolean = true
  ) {
    this.subscriptions.push(
      this._userService.loggedUserDetails.subscribe((data) => {
        if (data) {
          this.userDetails = data;
        } else {
          this.userDetails = [];
        }
      })
    );
    this.subscriptions.push(
      this._userService.userRole$.subscribe((data) => {
        this.userRole = data;
      })
    );
    expReport.reportName = setInvoiceExpReportName
      ? this.invoice.expenseReportName
      : expReport.reportName;
    expReport.userId = this.invoice.paidBy;
    expReport.invoiceId = this.invoice.id.toString();
    expReport.organizationId = this._organizationService.selectedOrganization;
    expReport.createdBy = this.userDetails.id;
    expReport.status = 1;
    expReport.id = '';
    this.creatingNewExpReport = true;
    this._invoiceService
      .createExpenseReport(JSON.parse(JSON.stringify(expReport)))
      .pipe(this.untilThis)
      .subscribe((result) => {
        this.invoice.expenseReportId = result.id;
        this.invoice.expenseReportName = expReport.reportName;
        this.isNewExpReport = false;
        this.creatingNewExpReport = false;
        this.isCreateExpReportItemShown = false;
        this.expClaims = [
          ...this.expClaims,
          { id: result.id, reportName: expReport.reportName },
        ];
        this.save('Expense Report');
      });
  }

  updateExpReportStatus() {
    if (this.invoice.expenseReportName != null) {
      const expReport = tryGetObjectByProperty(
        this.expClaims,
        'reportName',
        this.invoice.expenseReportName
      ) as SyncedExpClaims;
      this.isNewExpReportLoaded = expReport ? true : false;
      this.isNewExpReport =
        !expReport && !this.invoice.supplierId ? true : false;
      this.isCreateExpReportItemShown = this.isNewSupplier;
      this.newExpReport.reportName = this.invoice.expenseReportName;
      if (
        this.invoice.expenseReportId != null &&
        this.expClaims.length > 0 &&
        this.expClaims.find((p) => p.id == this.invoice.expenseReportId) != null
      ) {
        this.invoice.expenseReportName = this.expClaims.find(
          (p) => p.id == this.invoice.expenseReportId
        ).reportName;
      }
    }
  }

  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value;

    if (!reg.test(input)) {
      this.invoice.amountDue = Number(Number(input).toFixed(2));
      event.preventDefault();
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  saveReportBankDetails() {
    this.invoice.paymentStatus = InvoicePaymentStatus.AwaitingPayment;
    if (this.invoice.accountID != null && this.invoice.accountID != '') {
      this.invoice.paymentAccountNumber = this.invoice.accountID;
    }
    if (this.invoice.transactionDate != null) {
      this.invoice.paymentDate = this.invoice.transactionDate;
      this.saveInvoiceWithDelay('PaymentDate');
    }
  }

  /**
   * Returns the currently selected match, or null. Used by the collapsed
   * panel header to surface "which one is picked" without expanding the list.
   */
  get selectedMatch(): any | null {
    return (this.invoice?.unreconciledData || []).find((x: any) => x?.selected) || null;
  }

  toggleMatchPanel(): void {
    this.isMatchPanelExpanded = !this.isMatchPanelExpanded;
  }

  toggleShowAllMatches(): void {
    this.showAllMatches = !this.showAllMatches;
  }

  closeReportMatch() {
    this.showMatchDialog = false;
    this.maindivHeight = false;
  }

  matchUnreconciledData() {
    this.updateSuggestedMatches();
    this.isUpdateAfterPublish = false;
    if (this.isEditable) {
      this.publishInvoice();
    }
    else {
      this.closeFormOnMatch.emit();
    }
  }

  ignoreUnreconciledData() {
    this.updateSuggestedMatches();
  }
  updateSuggestedMatches() {
    let unreconciledReportIds = this.invoice.unreconciledData
      .map((a) => a.unreconciledReportId)
      .join(',');
    var model = {
      unreconciledReportIds: unreconciledReportIds,
      invoiceId: this.invoice.id,
      organizationId: this.invoice.organisationId,
    };
    this._invoiceService
      .updateSuggestedMatches(model)
      .pipe(take(1))
      .subscribe(
        () => {
          this.showMatchDialog = false;
          this.maindivHeight = false;
          this.unreconciledReportIds = unreconciledReportIds;
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.ErrorInbox,
            '',
            (e as any)?.error?.errorMessage || `Error!`
          );
        }
      );
  }

  calculateDivHeight() {
    var element = document.getElementById('floating-div');
    var formElement = document.getElementById('main-form');
    let totalheight = 0;
    if (element != null) {
      var floatingdivHeight = parseInt(
        document.defaultView
          .getComputedStyle(element, '')
          .getPropertyValue('height')
      );

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || environment.isOutlookEnv || environment.isChromeEnv;

      var windowheight = window?.innerHeight;
      if (isMobile) {
        totalheight = windowheight - floatingdivHeight - 115;
      } else {
        var formTop = formElement ? formElement.getBoundingClientRect().top : this.heightDeduct;
        totalheight = windowheight - floatingdivHeight - formTop;
      }

      return {
        'min-height': totalheight + 'px',
        height: totalheight + 'px',
        overflow: 'auto',
      };
    }
  }

  onChangePaymentStatus() {
    this.setFormValidator(this.invoice.type ? this.invoice.type : this.type);
    this.saveInvoiceWithDelay('Status');
  }

  ngAfterViewInit() {
    this.calculateDivHeight();
    // Ensure raw input is initialized with current amount
    if (this.invoice.amountDue !== undefined && this.invoice.amountDue !== null && (!this.amountDueRawInput || this.amountDueRawInput === '')) {
      this.amountDueRawInput = this.invoice.amountDue.toString();
    }
    if (!this.invoice.processed) {
      if (this.form) this.invoice.required_Fields = this.form.valid;
      else this.invoice.required_Fields = true;
    }
    else {
      this.invoice.required_Fields = true;
    }
    this.ngZone.onStable.subscribe(() => {
      if (!this.isEditable)
        this.autosize?.resizeToFitContent(true);
    });
  }

  changeSelectedMatch(event, id) {
    this.invoice.unreconciledData.forEach((num, index) => {
      this.invoice.unreconciledData[index].selected = false;
    });

    this.invoice.unreconciledData.find(
      (x) => x.unreconciledReportId == id
    ).selected = !event;
    if (
      this.invoice.unreconciledData.findIndex((x) => x.selected == true) > -1
    ) {
      this.isMatchPublish = true;
      this.selectedUnreconciledReportId = id;
      if (!this.invoice.processed) {
        let item = this.invoice.unreconciledData.find(
          (x) => x.unreconciledReportId == this.selectedUnreconciledReportId
        );
        if (item != null) {
          this.invoice.paymentStatus = InvoicePaymentStatus.AwaitingPayment;
          this.invoice.paymentDate = item.transactionDate;
          if (this.IsQuickBook) {
            this.MyBankAccount = this.bankAccountList.find(
              (x) => x.accountID === item.referenceId
            );
            this.invoice.paymentAccountNumber = item.referenceId;
          } else {
            this.MyBankAccount = this.bankAccountList.find(
              (x) => x.accountID === item.accountID
            );
            this.invoice.paymentAccountNumber = item.accountID;
          }
          if (this.currentSelectedMatch == "") {
            this.saveInvoiceWithDelay('PaymentDate');
          }
        }
      }
    } else {
      this.isMatchPublish = false;
      this.selectedUnreconciledReportId = '';
    }
  }

  checkIfMobileDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || environment.isOutlookEnv || environment.isChromeEnv) {
      // true for mobile device
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }

  expandCustomFields() {
    this.expanded = !this.expanded;
  }

  onCustomDateChange(field) {
    this.saveDateWhenFocusout();
  }

  editInvoice() {
    if (!this.IsNoAccounting) {
      const accInt = this.IsQuickBook ? 'QBO' : 'Xero';
      this._confirmationDialogService
        .confirm(
          'Confirm',
          'Please note that this will only update the record in Synced and not in ' +
          accInt +
          '. In order to do this please log into ' +
          accInt +
          ' and update there',
          'Yes',
          'No',
          ''
        )
        .then((confirm) => {
          if (confirm) {
            this.isEditable = true;
            this.isMatchPublish = false;
            this.updateCurrentSupplier();
          }
        });
    } else {
      this.isEditable = true;
      this.updateCurrentSupplier();
    }
  }

  toggleEntertainmentForm() {
    this.showEntertainmentForm = !this.showEntertainmentForm;
  }

  onEntertainmentDetailsSaved(details: any) {
    const task = this.tasks.find((t) => t.taskId === this.taskId);
    if (task) {
      task.complete = true;
    }
    details.customFields.forEach(
      (x) => (x.synced_invoice_id = this.invoice.id)
    );
    details.taskId = task.taskId;
    this.customFieldService
      .CreateFormFieldValues(details)
      .pipe()
      .subscribe((response: any) => {
        if (response.status === 1) {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Success,
            'Success',
            `Form created successfully`
          );
          if (this.invoiceTaskMode) {
            this.closeFormOnBillsToPayEvent.emit();
          }
        } else {
          this._toasterMessageService.displayToasterState(
            ToasterTypes.Error,
            'Error',
            response.message
          );
        }
      });
    this.pendingTaskCount = this.tasks.filter((t) => !t.complete).length;
    this.showApprovedTag =
      this.pendingTaskCount === 0 &&
      this.tasks?.find((t) => t.type === 'approval')?.complete === true;
    this.completedTasks = this.tasks.filter((t) => t.complete);
    this.completedTasks.forEach(
      (x) => (x.name = x.name.replace(' Required', ''))
    );
    this.currentTaskCompleted = true;
    // ...existing code...
  }

  openAssignDialog() {
    const dialogRef = this.dialog.open(FormAssignmentDialogComponent, {
      width: '500px',
      data: {
        invoiceId: this.invoice.id,
        formTypes: Object.values(this.formTypes),
        users: this.users,
      },
    });

    dialogRef.afterClosed().subscribe((result: FormAssignment) => {
      if (result) {
        this.handleFormAssignment(result);
      }
    });
  }

  // Admin (SuperAdmin=1 / Admin=2) can configure the panel display settings.
  // Prefer currentUser.role (loaded from logged-user details, survives refresh);
  // userRole$ is only set during the login flow so it's 0 on a hard refresh.
  // Coerce since role can arrive as a string.
  get isAdmin(): boolean {
    const role = Number(this.currentUser?.role ?? this.userRole);
    return role === 1 || role === 2 || role === 4; // Advisor has Admin's access
  }

  // True when the invoice date is more than 12 months before today. Soft prompt
  // only — never blocks publishing. Handles both Date objects and the entered
  // string form (parsed per the org's date format).
  get isInvoiceDateOld(): boolean {
    if (!this.invoice?.date) {
      return false;
    }
    const rawDate: any = this.invoice.date;
    let parsed: Date | null = null;
    if (rawDate instanceof Date) {
      parsed = rawDate;
    } else if (typeof rawDate === 'string') {
      parsed = parseDateByFormat(rawDate.trim(), this.dateFormat) || new Date(rawDate);
    } else {
      parsed = new Date(rawDate);
    }
    if (!parsed || isNaN(parsed.getTime())) {
      return false;
    }
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setFullYear(twelveMonthsAgo.getFullYear() - 1);
    return parsed < twelveMonthsAgo;
  }

  // Formats an account for display per the org's chosen account display mode.
  // Uses displayCode (Xero code / QBO AcctNum) — never `code`, which for QBO is
  // an internal id. Accounts without a display code show name only.
  accountLabel(item: PaymentAccount): string {
    if (!item) {
      return '';
    }
    if (this.displaySettings?.accountDisplay === 'codeAndName' && item.displayCode) {
      return `${item.displayCode} - ${item.name}`;
    }
    return item.name || '';
  }

  // ng-select search predicate: always matches name; also matches the account
  // code when the org displays code + name. Arrow fn to keep `this` bound.
  accountSearchFn = (term: string, item: PaymentAccount): boolean => {
    const t = (term || '').toLowerCase();
    return (
      (item?.name || '').toLowerCase().includes(t) ||
      (this.displaySettings?.accountDisplay === 'codeAndName' &&
        (item?.displayCode || '').toLowerCase().includes(t))
    );
  };

  // Loads the org-level invoice panel display settings, using the shared cache so
  // an edit made via the dialog reflects immediately without a refetch.
  loadDisplaySettings() {
    this._organizationService
      .getInvoiceDisplaySettings(this._organizationService.selectedOrganization)
      .pipe(take(1))
      .subscribe(
        (response) => {
          // SD: the panel binds to `this.displaySettings`, so it MUST be assigned here — pushing
          // only to the service subject (whose sync subscription was disabled) left the panel stuck
          // on the defaults, so saved options like Planned Date / Code+Name never appeared.
          const settings = this.mergeDisplaySettings(response && response.settings);
          this.displaySettings = settings;
          this._organizationService.setInvoiceDisplaySettings(settings);
        },
        () => {
          // Fail safe: keep the defaults so the panel still renders.
        }
      );
  }

  /** Merge stored settings over the defaults so a partial/absent payload can't drop fields. */
  private mergeDisplaySettings(source: InvoiceDisplaySettings | null | undefined): InvoiceDisplaySettings {
    if (!source) return DEFAULT_INVOICE_DISPLAY_SETTINGS;
    return {
      fields: { ...DEFAULT_INVOICE_DISPLAY_SETTINGS.fields, ...source.fields },
      accountDisplay: source.accountDisplay || DEFAULT_INVOICE_DISPLAY_SETTINGS.accountDisplay,
    };
  }

  openDisplaySettingsDialog() {
    const dialogRef = this.dialog.open(InvoiceDisplaySettingsDialogComponent, {
      width: '480px',
      data: {
        settings: this.displaySettings,
        isXero: this.IsXero,
        isQuickBook: this.IsQuickBook,
        organisationId: this._organizationService.selectedOrganization,
      },
    });

    dialogRef.afterClosed().subscribe((result: InvoiceDisplaySettings) => {
      if (result) {
        // Apply immediately so the panel reflects the change the moment the dialog closes —
        // the panel renders from `this.displaySettings`, not the service subject.
        this.displaySettings = this.mergeDisplaySettings(result);
        this._organizationService.setInvoiceDisplaySettings(this.displaySettings);
      }
    });
  }

  private handleFormAssignment(assignment: FormAssignment) {
    assignment.status = AssignmentStatus.Pending;

    const assignmentVar = {
      name: assignment.formType.form_name + ' Required',
      date: new Date(),
      dueDate: assignment.dueDate,
      assignedToUserId: assignment.assignedTo,
      complete: false,
      taskUrl: assignment.formType.custom_form_id,
      organisationId: this._organizationService.selectedOrganization,
      invoiceId: this.invoice.id,
      invoiceDate: this.invoice.date,
      invoiceDueDate: this.invoice.dueDate,
      total: this.invoice.total,
      comment: this.invoice.description,
      invoiceNumber: this.invoice.invoiceNumber,
      urlName: this.invoice.invoiceNumber,
    };

    this._invoiceService.assignInvoice(assignmentVar).subscribe((data) => {
      this.loading = false;
      // If self-assigned, open the form directly
      if (assignment.assignedTo === this.user.id) {
        this._toasterMessageService.displayToasterState(
          ToasterTypes.Success,
          'Success',
          `Form assigned to you.`
        );
        this.openAssignedForm(assignment.formType);
      } else {
        // Otherwise send notification to assigned user
        this._toasterMessageService.displayToasterState(
          ToasterTypes.Success,
          'Success',
          `Form assigned to ${this.users.find((u) => u.id === assignment.assignedTo)?.name
          }`
        );
      }
      this.GetApprovalAssignDetail();
    });
  }

  GetApprovalAssignDetail() {
    this.reportService
      .GetTaskDetail(
        this._organizationService.selectedOrganization,
        this.invoice.id
      )
      .subscribe((response) => {
        if (response.status == 1) {
          this.tasks = response.data;
          this.pendingTaskCount = this.tasks.filter((t) => !t.complete).length;
          this.showApprovedTag =
            this.pendingTaskCount === 0 &&
            this.tasks?.find((t) => t.type === 'approval')?.complete === true;
          this.completedTasks = this.tasks.filter((t) => t.complete);
          this.completedTasks.forEach(
            (x) => (x.name = x.name.replace(' Required', ''))
          );
        } else {
          this.pendingTaskCount = 0;
          this.showApprovedTag = false;
          this.completedTasks = [];
        }
      });
  }

  private openAssignedForm(formType: FormType) {
    switch (formType) {
      case FormType.EntertainmentDetails:
        this.showEntertainmentForm = true;
        break;
      // Add other form types as needed
    }
  }

  // Add new method to handle local currency updates
  updateLocalCurrency(amount: number) {
    this.localCurrencyWasChanged = true;
    this.invoice.localCurrencyAmount = amount;
    if (amount && this.invoice.amountDue) {
      this.exchangeRate = +(amount / this.invoice.amountDue).toFixed(4);
      //this.invoice.amountDue = Number((this.invoice.localCurrencyAmount / this.exchangeRate).toFixed(2));
    } else {
      this.invoice.amountDue = this.invoice.localCurrencyAmount;
    }
    //this.saveInvoiceWithDelay('Local Currency');
  }

  // Replace handleApprovalClick with new task handlers
  showTaskDetails(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    const dialogRef = this.dialog.open(TaskDetailsDialogComponent, {
      width: '250px',
      data: {
        tasks: this.tasks.filter((t) => !t.complete),
      },
      position: {
        top: `${rect.bottom + 5}px`,
        left: `${rect.left}px`,
      },
      panelClass: 'tasks-dropdown',
      hasBackdrop: true,
      backdropClass: 'transparent-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.formId = result.formId;
        this.taskId = result.taskId;
        this.formName = result.formName.replace(' Required', '');
        if (result.type === 'approval') {
          this.completeApprovalTask();
        } else {
          this.customFieldService
            .GetFieldsByForm(
              result.formId,
              this._organizationService.selectedOrganization
            )
            .pipe()
            .subscribe((fieldsResponse: any) => {
              if (fieldsResponse.status === 1) {
                this.customFormFields = fieldsResponse.data || [];
                this.customFormFields.forEach((x) => {
                  if (x.options) x.optionsArr = x.options.split(',');
                });
              }
              this.loading = false;
              this.toggleEntertainmentForm();
            });
        }
      }
    });
  }

  openCompletedTaskForm(task) {
    this.customFieldService
      .GetAllInvoiceRelatedData(
        task.taskId,
        this._organizationService.selectedOrganization
      )
      .pipe()
      .subscribe((fieldsResponse: any) => {
        if (fieldsResponse.status === 1) {
          this.customFormFields = fieldsResponse.data || [];
          this.customFormFields.forEach((x) => {
            if (x.options) x.optionsArr = x.options.split(',');
          });
        }
        this.formName = task.formName;
        this.assignToUserName = task.assignToUserName;
        this.loading = false;
        this.isFormEditable = false;
        this.toggleEntertainmentForm();
      });
  }

  private completeApprovalTask() {
    const task = this.tasks.find((t) => t.type === 'approval');
    if (task) {
      task.complete = true;
      this.showApprovalAnimation = true;

      setTimeout(() => {
        this.showApprovalAnimation = false;
      }, 1500);
    }
  }
  closeForm() {
    this.isFormEditable = true;
  }

  onCurrencyChange(currency: string) {
    this.showLocalCurrency = currency !== this.defaultCurrency;

    // Reset and initialize local currency values when switching currencies
    if (this.showLocalCurrency && this.invoice.amountDue) {
      of(this.getExchangeRateAndCalculateLocalAmount())
        .pipe()
        .subscribe((result) => {
          // Save after currency change
          this.saveInvoiceWithDelay('Currency', 3000);
        });
    } else {
      this.invoice.localCurrencyAmount = null;
      this.exchangeRate = null;
      // Save after currency change
      this.saveInvoiceWithDelay('Currency');
    }
  }

  private getExchangeRateAndCalculateLocalAmount() {
    if (
      this.showLocalCurrency &&
      this.invoice.amountDue &&
      this.invoice.date &&
      this.invoice.currency
    ) {
      this._invoiceService
        .getExchangeRate(this.invoice.currency, this.invoice.date.toDateString(), this.invoice.amountDue)
        .pipe(take(1))
        .subscribe(
          (response: any) => {
            if (response && response[this.defaultCurrency.toLowerCase()]) {
              const exchangeRate =
                response[this.defaultCurrency.toLowerCase()];
              if (exchangeRate) {
                this.invoice.localCurrencyAmount = +exchangeRate.toFixed(2);
                this.exchangeRate = +(
                  this.invoice.localCurrencyAmount / this.invoice.amountDue
                ).toFixed(4);
                return exchangeRate;
              } else {
                this._toasterMessageService.displayToasterState(
                  ToasterTypes.Warning,
                  'Warning',
                  `Exchange rate not found for ${this.defaultCurrency}`
                );
                this.invoice.localCurrencyAmount = this.invoice.amountDue;
                this.exchangeRate = 1;
                return exchangeRate;
              }
            } else {
              this._toasterMessageService.displayToasterState(
                ToasterTypes.Error,
                'Error',
                'Failed to fetch exchange rate'
              );
              this.invoice.localCurrencyAmount = this.invoice.amountDue;
              this.exchangeRate = 1;
              return 1;
            }
          },
          (error: any) => {
            console.error('API Error:', error);
            this._toasterMessageService.displayToasterState(
              ToasterTypes.Error,
              'Error',
              'Failed to fetch exchange rate'
            );
            this.invoice.localCurrencyAmount = this.invoice.amountDue;
            this.exchangeRate = 1;
          }
        );
    }
  }

  // Status pill integration detection methods
  setIntegrationType(): void {
    const org = this._organizationService.organizationList?.value?.find(
      org => org.organisationID === this._organizationService.selectedOrganization
    );

    if (org) {
      this.integrationType = org.accountingIntegration === AccountingIntegration.QBO
        ? 'QBO'
        : org.accountingIntegration === AccountingIntegration.None
          ? 'None'
          : 'Xero';
    } else {
      this.integrationType = 'None';
    }
  }

  getIntegrationType(): 'Xero' | 'QBO' | 'None' {
    if (!this.integrationType) {
      this.setIntegrationType();
    }
    return this.integrationType;
  }

  getInvoiceStatus(): string {
    // Map the invoice payment status to status pill text
    // You may need to adjust this mapping based on your invoice model
    return fromCamelCase(this.invoice.status);
  }

  evaluateExpression(input: string): number {
    const expr = input.trim();
    if (!/^[\d+\-*/%^().\s]+$/.test(expr)) throw new Error('Invalid characters');

    const tokens = expr.match(/\d+(?:\.\d+)?|[()+\-*/%^]/g) ?? [];
    const out: string[] = [], ops: string[] = [];
    const prec: Record<string, number> = { '^': 4, '*': 3, '/': 3, '%': 3, '+': 2, '-': 2 };
    const right = new Set(['^']);
    const isOp = (t: string) => t in prec;
    const isNum = (t: string) => /^-?\d+(?:\.\d+)?$/.test(t);
    let prev: string | null = null;

    for (let i = 0; i < tokens.length; i++) {
      let t = tokens[i];

      if (t === '-' && (prev == null || prev === '(' || isOp(prev))) {
        const nxt = tokens[i + 1];
        if (nxt && /^\d+(?:\.\d+)?$/.test(nxt)) { out.push(String(-parseFloat(nxt))); i++; prev = nxt; continue; }
        if (nxt === '(') { out.push('0'); ops.push('-'); prev = t; continue; }
        throw new Error('Invalid unary minus');
      }

      if (/^\d+(?:\.\d+)?$/.test(t)) out.push(t);
      else if (isOp(t)) {
        while (ops.length && isOp(ops[ops.length - 1]) &&
          (prec[ops[ops.length - 1]] > prec[t] ||
            (prec[ops[ops.length - 1]] === prec[t] && !right.has(t)))) {
          out.push(ops.pop()!);
        }
        ops.push(t);
      } else if (t === '(') ops.push(t);
      else if (t === ')') {
        while (ops.length && ops[ops.length - 1] !== '(') out.push(ops.pop()!);
        if (ops.pop() !== '(') throw new Error('Mismatched parentheses');
      } else throw new Error('Invalid token');

      prev = t;
    }
    while (ops.length) {
      const op = ops.pop()!;
      if (op === '(') throw new Error('Mismatched parentheses');
      out.push(op);
    }

    const stack: number[] = [];
    for (const t of out) {
      if (isNum(t)) { stack.push(parseFloat(t)); continue; }
      const b = stack.pop(); const a = stack.pop();
      if (a === undefined || b === undefined) throw new Error('Malformed expression');
      switch (t) {
        case '+': stack.push(a + b); break;
        case '-': stack.push(a - b); break;
        case '*': stack.push(a * b); break;
        case '/': if (b === 0) throw new Error('Division by zero'); stack.push(a / b); break;
        case '%': stack.push(a % b); break;
        case '^': stack.push(Math.pow(a, b)); break;
        default: throw new Error('Unknown operator');
      }
    }
    if (stack.length !== 1) throw new Error('Malformed expression');
    return stack[0];
  }
  saveDefaultTax() {
    this.updateSettings(new UpdatedSettings(
      this._organizationService.selectedOrganization,
      2,
      this.selectedTaxRateId ?? null, null, null));
  }

  updateSettings(updatedSettings: UpdatedSettings) {
    this.loading = true;
    this._organizationService.updateOrganizationTaxSettings(updatedSettings)
      .pipe(this.untilThis,
        finalize(() => this.loading = false))
      .subscribe(
        () => {
          this.DefaultTaxModel.hide();
          this._toasterMessageService.displayToasterState(ToasterTypes.Success, 'Success', 'Settings updated!');
          location.reload();
        },
        (e: Error) => {
          this._toasterMessageService.displayToasterState(ToasterTypes.Error, 'Error', e.message);
        }
      )
  }

  onPasteFix(event: ClipboardEvent) {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '').substring(0, 6);

    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + '-' + digits.substring(3);
    }

    const input = event.target as HTMLInputElement;
    input.value = formatted;

    // 🔥 Force ngx-mask to reprocess
    input.dispatchEvent(new Event('input'));
  }
  get publishButtonText(): string {
    if (this.loading) {
      return this.isMatchPublish ? 'Matching...' : 'Publishing...';
    }

    if (this.isMatchPublish) {
      if (this.isEditable && !this.invoice.processed) {
        return 'Match & Publish';
      }
      if (!this.isEditable) {
        return 'Match';
      }
    }

    if (this.isEditable) {
      return 'Publish';
    }

    return 'Action';
  }
}
